"use strict";

/*==============================================================================*
*TRESTLE W007
*YOUR TRESTLE INSIGHT
*ENGINE
*Version 2.0
*
*SECTION A
*ENGINE FOUNDATION
*SOURCE READERS
*NORMALIZATION
*
*No DOM rendering here.
*No PDF generation here.
*No Share logic here.
*==============================================================================*/

(function(){

/*==============================================================================*
*ENGINE CONFIG
*==============================================================================*/

const ENGINE_CONFIG={

    version:"2.0",

    generationHour:19,

    generationMinute:0,

    archiveKey:"trestle_w007_insights",

    archiveLimit:7

};


/*==============================================================================*
*RUNTIME
*==============================================================================*/

let insightData=null;

let profileContext=null;

let identityContext=null;

let todayW005=null;


/*==============================================================================*
*LOAD CONTROLLED W007 DATA
*==============================================================================*/

function loadInsightData(){

    if(
        typeof window.TRESTLE_W007_INSIGHT_DATA==="undefined" ||
        !window.TRESTLE_W007_INSIGHT_DATA
    ){

        console.warn(
            "TRESTLE W007: Insight Data file is unavailable."
        );

        return null;

    }


    insightData=
        window.TRESTLE_W007_INSIGHT_DATA;


    return insightData;

}


/*==============================================================================*
*DATE KEY
*==============================================================================*/

function getTodayKey(){

    const now=
        new Date();


    const year=
        now.getFullYear();


    const month=
        String(
            now.getMonth()+1
        ).padStart(
            2,
            "0"
        );


    const day=
        String(
            now.getDate()
        ).padStart(
            2,
            "0"
        );


    return(
        year+
        "-"+
        month+
        "-"+
        day
    );

}


/*==============================================================================*
*TIMESTAMP
*==============================================================================*/

function getTimestamp(){

    return new Date().toISOString();

}


/*==============================================================================*
*IS AFTER GENERATION TIME
*==============================================================================*/

function isAfterGenerationTime(){

    const now=
        new Date();


    const hour=
        now.getHours();


    const minute=
        now.getMinutes();


    if(
        hour>ENGINE_CONFIG.generationHour
    ){

        return true;

    }


    if(
        hour<ENGINE_CONFIG.generationHour
    ){

        return false;

    }


    return(
        minute>=ENGINE_CONFIG.generationMinute
    );

}


/*==============================================================================*
*DEEP COPY
*==============================================================================*/

function clone(value){

    if(
        value===null ||
        typeof value==="undefined"
    ){

        return value;

    }


    return JSON.parse(
        JSON.stringify(
            value
        )
    );

}


/*==============================================================================*
*SAFE STRING
*==============================================================================*/

function safeString(value){

    if(
        value===null ||
        typeof value==="undefined"
    ){

        return"";

    }


    return String(value).trim();

}


/*==============================================================================*
*SAFE NUMBER
*==============================================================================*/

function safeNumber(value){

    const number=
        Number(value);


    if(
        !Number.isFinite(number)
    ){

        return null;

    }


    return number;

}


/*==============================================================================*
*VALID TIME VALUE
*
*Expected:
*HH:MM
*==============================================================================*/

function isValidTimeValue(value){

    if(
        typeof value!=="string"
    ){

        return false;

    }


    return(
        /^([01]\d|2[0-3]):([0-5]\d)$/
            .test(value)
    );

}


/*==============================================================================*
*TIME TO MINUTES
*==============================================================================*/

function timeToMinutes(value){

    if(
        !isValidTimeValue(value)
    ){

        return null;

    }


    const parts=
        value.split(":");


    const hours=
        Number(parts[0]);


    const minutes=
        Number(parts[1]);


    return(
        hours*60+
        minutes
    );

}


/*==============================================================================*
*FORMAT EVENT TIME
*==============================================================================*/

function formatEventTime(value){

    if(
        !isValidTimeValue(value)
    ){

        return"";

    }


    const parts=
        value.split(":");


    let hour=
        Number(parts[0]);


    const minute=
        parts[1];


    const period=
        hour>=12
            ? "PM"
            : "AM";


    hour=
        hour%12 || 12;


    return(
        hour+
        ":"+
        minute+
        " "+
        period
    );

}


/*==============================================================================*
*READ SHOPIFY / TRESTLE IDENTITY
*
*Identity must come from the authenticated Shopify/TRESTLE workspace layer.
*
*W007 does not create or store a duplicate user identity.
*==============================================================================*/

function readIdentityContext(){

    let firstName="";


    /*==========================================================================
    PRIMARY
    Existing Shopify customer injection
    ==========================================================================*/

    if(
        window.TrestleCustomer &&
        typeof window.TrestleCustomer==="object"
    ){

        firstName=
            safeString(
                window.TrestleCustomer.firstName
            );

    }


    /*==========================================================================
    OPTIONAL WORKSPACE FALLBACK
    If the workspace later exposes identity through its public API/object.
    ==========================================================================*/

    if(
        !firstName &&
        window.TrestleWorkspace &&
        typeof window.TrestleWorkspace==="object"
    ){

        if(
            typeof window.TrestleWorkspace.getUser==="function"
        ){

            try{

                const user=
                    window.TrestleWorkspace.getUser();


                if(user){

                    firstName=
                        safeString(
                            user.firstName ||
                            user.name
                        );

                }

            }

            catch(error){

                console.warn(
                    "TRESTLE W007: Workspace identity fallback unavailable.",
                    error
                );

            }

        }

    }


    identityContext={

        firstName:
            firstName

    };


    return clone(
        identityContext
    );

}


/*==============================================================================*
*READ W002 PROFILE CONTEXT
*
*W007 requires only:
*
*My Promise
*Life Stage
*Diabetes Profile
*
*W007 should never maintain an independent profile copy.
*==============================================================================*/

function readProfileContext(){

    let promise="";

    let lifeStage="";

    let diabetesProfile="";


/*==========================================================================
PREFERRED W002 PUBLIC API
==========================================================================*/

try{

    let profile=null;


    /*
    Current production W002 API
    */

    if(
        typeof W002!=="undefined" &&
        W002 &&
        typeof W002.getProfile==="function"
    ){

        profile=
            W002.getProfile();

    }


    /*
    Future / alternate namespace compatibility
    */

    else if(
        window.TrestleW002 &&
        typeof window.TrestleW002==="object" &&
        typeof window.TrestleW002.getProfile==="function"
    ){

        profile=
            window.TrestleW002.getProfile();

    }


    /*
    Direct localStorage fallback.
    W002 remains the owner of this profile.
    W007 only reads it.
    */

    else{

        const stored=
            localStorage.getItem(
                "trestleProfile"
            );


        if(stored){

            profile=
                JSON.parse(
                    stored
                );

        }

    }


    if(profile){

        promise=
            safeString(
                profile.promise ||
                profile.myPromise
            );


        lifeStage=
            safeString(
                profile.lifeStage
            );


        diabetesProfile=
            safeString(
                profile.diabetesProfile ||
                profile.diabetesType
            );

    }

}

catch(error){

    console.warn(
        "TRESTLE W007: W002 profile could not be read.",
        error
    );

}


    /*==========================================================================
    OPTIONAL SHARED WORKSPACE PROFILE FALLBACK
    ==========================================================================*/

    if(
        (
            !promise ||
            !lifeStage ||
            !diabetesProfile
        ) &&
        window.TrestleProfile &&
        typeof window.TrestleProfile==="object"
    ){

        promise=
            promise ||
            safeString(
                window.TrestleProfile.promise ||
                window.TrestleProfile.myPromise
            );


        lifeStage=
            lifeStage ||
            safeString(
                window.TrestleProfile.lifeStage
            );


        diabetesProfile=
            diabetesProfile ||
            safeString(
                window.TrestleProfile.diabetesProfile ||
                window.TrestleProfile.diabetesType
            );

    }


    profileContext={

        promise:
            normalizePromise(
                promise
            ),

        lifeStage:
            normalizeLifeStage(
                lifeStage
            ),

        diabetesProfile:
            normalizeDiabetesProfile(
                diabetesProfile
            )

    };


    return clone(
        profileContext
    );

}


/*==============================================================================*
*NORMALIZE PROMISE
*==============================================================================*/

function normalizePromise(value){

    const text=
        safeString(value);


    if(
        !insightData ||
        !Array.isArray(
            insightData.promises
        )
    ){

        return text;

    }


    const matched=
        insightData.promises.find(

            function(item){

                return(
                    item.toLowerCase()===
                    text.toLowerCase()
                );

            }

        );


    return matched || "";

}


/*==============================================================================*
*NORMALIZE LIFE STAGE
*==============================================================================*/

function normalizeLifeStage(value){

    const text=
        safeString(value);


    if(
        !insightData ||
        !Array.isArray(
            insightData.lifeStages
        )
    ){

        return text;

    }


    const matched=
        insightData.lifeStages.find(

            function(item){

                return(
                    item.toLowerCase()===
                    text.toLowerCase()
                );

            }

        );


    return matched || "";

}


/*==============================================================================*
*NORMALIZE DIABETES PROFILE
*==============================================================================*/

function normalizeDiabetesProfile(value){

    const text=
        safeString(value);


    if(
        !insightData ||
        !Array.isArray(
            insightData.diabetesProfiles
        )
    ){

        return text;

    }


    const matched=
        insightData.diabetesProfiles.find(

            function(item){

                return(
                    item.toLowerCase()===
                    text.toLowerCase()
                );

            }

        );


    return matched || "";

}


/*==============================================================================*
*READ TODAY'S W005 DATA
*==============================================================================*/

function readTodayW005(){

    if(
        !window.TrestleW005 ||
        typeof window.TrestleW005.getToday!=="function"
    ){

        console.warn(
            "TRESTLE W007: W005 API is unavailable."
        );

        return null;

    }


    try{

        const data=
            window.TrestleW005.getToday();


        if(
            !data ||
            typeof data!=="object"
        ){

            return null;

        }


        todayW005=
            normalizeW005(
                data
            );


        return clone(
            todayW005
        );

    }

    catch(error){

        console.warn(
            "TRESTLE W007: Unable to read W005 data.",
            error
        );


        return null;

    }

}


/*==============================================================================*
*NORMALIZE W005
*==============================================================================*/

function normalizeW005(raw){

    const normalized={

        date:
            safeString(
                raw.date
            ) || getTodayKey(),

        latest:{},

        history:{

            bloodSugar:[],

            meal:[],

            movement:[]

        }

    };


    const latest=
        (
            raw.latest &&
            typeof raw.latest==="object"
        )
            ? raw.latest
            : {};


    [

        "bloodSugar",

        "meal",

        "medication",

        "water",

        "movement",

        "mood",

        "stress",

        "sleep"

    ].forEach(

        function(type){

            normalized.latest[type]=

                normalizeEntry(

                    latest[type],

                    type

                );

        }

    );


    const history=
        (
            raw.history &&
            typeof raw.history==="object"
        )
            ? raw.history
            : {};


    [

        "bloodSugar",

        "meal",

        "movement"

    ].forEach(

        function(type){

            const entries=
                Array.isArray(
                    history[type]
                )
                    ? history[type]
                    : [];


            normalized.history[type]=

                entries

                    .map(

                        function(entry){

                            return normalizeEntry(
                                entry,
                                type
                            );

                        }

                    )

                    .filter(Boolean);

        }

    );


    return normalized;

}


/*==============================================================================*
*NORMALIZE W005 ENTRY
*==============================================================================*/

function normalizeEntry(entry,type){

    if(
        !entry ||
        typeof entry!=="object"
    ){

        return null;

    }


    const data=
        (
            entry.data &&
            typeof entry.data==="object"
        )
            ? entry.data
            : {};


    const normalized={

        id:
            safeString(
                entry.id
            ),

        type:
            safeString(
                entry.type
            ) || type,

        timestamp:
            safeString(
                entry.timestamp
            ),

        updatedAt:
            safeString(
                entry.updatedAt
            ),

        data:{}

    };


    switch(type){


        /*======================================================================*
        *BLOOD SUGAR
        *======================================================================*/

        case "bloodSugar":

            normalized.data={

                value:
                    safeNumber(
                        data.value
                    ),

                unit:
                    safeString(
                        data.unit
                    ) || "mg/dL",

                context:
                    safeString(
                        data.context
                    ),

                eventTime:
                    isValidTimeValue(
                        data.eventTime
                    )
                        ? data.eventTime
                        : "",

                note:
                    safeString(
                        data.note
                    )

            };

            break;



        /*======================================================================*
        *MEAL
        *======================================================================*/

        case "meal":

            normalized.data={

                mealType:
                    safeString(
                        data.mealType
                    ),

                eventTime:
                    isValidTimeValue(
                        data.eventTime
                    )
                        ? data.eventTime
                        : "",

                food:
                    safeString(
                        data.food
                    )

            };

            break;



        /*======================================================================*
        *MEDICATION
        *======================================================================*/

        case "medication":

            normalized.data={

                status:
                    safeString(
                        data.status
                    ),

                eventTime:
                    isValidTimeValue(
                        data.eventTime
                    )
                        ? data.eventTime
                        : "",

                note:
                    safeString(
                        data.note
                    )

            };

            break;



        /*======================================================================*
        *WATER
        *======================================================================*/

        case "water":

            normalized.data={

                glasses:
                    safeNumber(
                        data.glasses
                    )

            };

            break;



        /*======================================================================*
        *MOVEMENT
        *======================================================================*/

        case "movement":

            normalized.data={

                activity:
                    safeString(
                        data.activity
                    ),

                minutes:
                    safeNumber(
                        data.minutes
                    ),

                note:
                    safeString(
                        data.note
                    )

            };

            break;



        /*======================================================================*
        *MOOD
        *======================================================================*/

        case "mood":

            normalized.data={

                mood:
                    safeString(
                        data.mood
                    ),

                note:
                    safeString(
                        data.note
                    )

            };

            break;



        /*======================================================================*
        *STRESS
        *======================================================================*/

        case "stress":

            normalized.data={

                level:
                    safeString(
                        data.level
                    ),

                source:
                    safeString(
                        data.source
                    ),

                note:
                    safeString(
                        data.note
                    )

            };

            break;



        /*======================================================================*
        *SLEEP
        *======================================================================*/

        case "sleep":

            normalized.data={

                hours:
                    safeNumber(
                        data.hours
                    ),

                quality:
                    safeString(
                        data.quality
                    ),

                note:
                    safeString(
                        data.note
                    )

            };

            break;

    }


    return normalized;

}


/*==============================================================================*
*GET W005 HISTORY
*==============================================================================*/

function getHistory(type){

    if(
        !todayW005 ||
        !todayW005.history ||
        !Array.isArray(
            todayW005.history[type]
        )
    ){

        return[];

    }


    return clone(
        todayW005.history[type]
    );

}


/*==============================================================================*
*GET W005 LATEST
*==============================================================================*/

function getLatest(type){

    if(
        !todayW005 ||
        !todayW005.latest
    ){

        return null;

    }


    return clone(
        todayW005.latest[type]
    );

}


/*==============================================================================*
*COUNT DISTINCT CHECK-IN DOMAINS
*
*Counts different W005 areas recorded today.
*
*This is used for data coverage only.
*It is NOT shown as a score.
*==============================================================================*/

function countRecordedDomains(){

    if(!todayW005){

        return 0;

    }


    return [

        "bloodSugar",

        "meal",

        "medication",

        "water",

        "movement",

        "mood",

        "stress",

        "sleep"

    ].filter(

        function(type){

            if(
                type==="bloodSugar" ||
                type==="meal" ||
                type==="movement"
            ){

                return(
                    getHistory(type).length>0 ||
                    Boolean(
                        getLatest(type)
                    )
                );

            }


            return Boolean(
                getLatest(type)
            );

        }

    ).length;

}


/*==============================================================================*
*DETERMINE DATA COVERAGE LEVEL
*==============================================================================*/

function getDataCoverageLevel(){

    const count=
        countRecordedDomains();


    if(count===0){

        return"NONE";

    }


    if(count===1){

        return"VERY_LIGHT";

    }


    if(
        count>=2 &&
        count<=3
    ){

        return"LIGHT";

    }


    return"FULL";

}


/*==============================================================================*
*READ ALL ENGINE INPUTS
*==============================================================================*/

function readEngineInputs(){

    if(
        !loadInsightData()
    ){

        return null;

    }


    const identity=
        readIdentityContext();


    const profile=
        readProfileContext();


    const w005=
        readTodayW005();


    return{

        identity:
            identity,

        profile:
            profile,

        w005:
            w005,

        date:
            getTodayKey(),

        afterGenerationTime:
            isAfterGenerationTime(),

        dataCoverageLevel:
            getDataCoverageLevel()

    };

}


/*==============================================================================*
*PUBLIC DEBUG / READ API
*
*Temporary but useful while W007 is being built.
*
*This exposes normalized input only.
*No Insight generation yet.
*==============================================================================*/

window.TrestleW007Engine={


    getInputs:function(){

        return clone(
            readEngineInputs()
        );

    },


    getIdentity:function(){

        if(!insightData){

            loadInsightData();

        }


        return clone(
            readIdentityContext()
        );

    },


    getProfile:function(){

        if(!insightData){

            loadInsightData();

        }


        return clone(
            readProfileContext()
        );

    },


    getTodayW005:function(){

        if(!insightData){

            loadInsightData();

        }


        return clone(
            readTodayW005()
        );

    },


    isAfterGenerationTime:function(){

        return isAfterGenerationTime();

    },


    getDataCoverageLevel:function(){

        if(!todayW005){

            readTodayW005();

        }


        return getDataCoverageLevel();

    }

};


/*==============================================================================*
*SECTION A END
*
*SECTION B CONTINUES DIRECTLY BELOW.
*
*DO NOT ADD })(); YET.
*==============================================================================*/
/*==============================================================================*
*SECTION B
*DERIVED PATTERN ENGINE
*CALCULATED FACTS
*
*Converts normalized W005 data into:
*
*1. Direct observation flags
*2. Calculated facts
*3. Safe cross-pattern flags
*
*No report wording is generated here.
*==============================================================================*/


/*==============================================================================*
*PATTERN RUNTIME
*==============================================================================*/

let derivedPatterns=null;

let calculatedFacts=null;


/*==============================================================================*
*CREATE EMPTY PATTERN STATE
*==============================================================================*/

function createPatternState(){

    return{

        flags:{},

        domains:{},

        values:{},

        crossPatterns:[],

        dataCoverage:{

            checkinsLogged:0,

            bloodSugarReadings:0,

            mealsRecorded:0,

            movementSessions:0,

            dataLevel:"NONE"

        }

    };

}


/*==============================================================================*
*SET PATTERN
*==============================================================================*/

function setPattern(state,id,domain,value){

    if(
        !state ||
        !id
    ){

        return;

    }


    state.flags[id]=true;


    if(domain){

        if(
            !Array.isArray(
                state.domains[domain]
            )
        ){

            state.domains[domain]=[];

        }


        if(
            !state.domains[domain].includes(id)
        ){

            state.domains[domain].push(id);

        }

    }


    if(
        typeof value!=="undefined"
    ){

        state.values[id]=value;

    }

}


/*==============================================================================*
*HAS PATTERN
*==============================================================================*/

function hasPattern(state,id){

    return Boolean(

        state &&
        state.flags &&
        state.flags[id]

    );

}


/*==============================================================================*
*COUNT UNIQUE VALUES
*==============================================================================*/

function countUnique(values){

    return new Set(

        values
            .filter(Boolean)
            .map(
                function(value){

                    return String(value);

                }
            )

    ).size;

}


/*==============================================================================*
*SORT ENTRIES BY EVENT TIME
*
*Entries without valid eventTime are placed after timed entries.
*==============================================================================*/

function sortByEventTime(entries){

    return entries
        .slice()
        .sort(

            function(a,b){

                const timeA=
                    a &&
                    a.data
                        ? timeToMinutes(
                            a.data.eventTime
                        )
                        : null;


                const timeB=
                    b &&
                    b.data
                        ? timeToMinutes(
                            b.data.eventTime
                        )
                        : null;


                if(
                    timeA===null &&
                    timeB===null
                ){

                    return 0;

                }


                if(timeA===null){

                    return 1;

                }


                if(timeB===null){

                    return -1;

                }


                return timeA-timeB;

            }

        );

}


/*==============================================================================*
*DERIVE SLEEP PATTERNS
*==============================================================================*/

function deriveSleepPatterns(state){

    const entry=
        getLatest("sleep");


    if(
        !entry ||
        !entry.data
    ){

        setPattern(
            state,
            "sleep_not_logged",
            "sleep"
        );

        return;

    }


    const hours=
        safeNumber(
            entry.data.hours
        );


    const quality=
        safeString(
            entry.data.quality
        );


    setPattern(
        state,
        "sleep_recorded",
        "sleep"
    );


    if(hours!==null){

        state.values.sleepHours=
            hours;


        if(hours<6){

            setPattern(
                state,
                "clearly_shorter_sleep",
                "sleep",
                hours
            );

        }

        else if(
            hours>=6 &&
            hours<7
        ){

            setPattern(
                state,
                "shorter_sleep",
                "sleep",
                hours
            );

        }

        else if(
            hours>=7 &&
            hours<=9
        ){

            setPattern(
                state,
                "adult_sleep_reference_met",
                "sleep",
                hours
            );

        }

        else if(hours>9){

            setPattern(
                state,
                "longer_sleep_recorded",
                "sleep",
                hours
            );

        }

    }


    if(quality){

        state.values.sleepQuality=
            quality;


        if(quality==="Good"){

            setPattern(
                state,
                "sleep_quality_good",
                "sleep"
            );

        }


        if(quality==="Average"){

            setPattern(
                state,
                "sleep_quality_average",
                "sleep"
            );

        }


        if(quality==="Poor"){

            setPattern(
                state,
                "sleep_quality_poor",
                "sleep"
            );

        }

    }

}


/*==============================================================================*
*DERIVE STRESS PATTERNS
*==============================================================================*/

function deriveStressPatterns(state){

    const entry=
        getLatest("stress");


    if(
        !entry ||
        !entry.data
    ){

        setPattern(
            state,
            "stress_not_logged",
            "stress"
        );

        return;

    }


    const level=
        safeString(
            entry.data.level
        );


    setPattern(
        state,
        "stress_recorded",
        "stress"
    );


    state.values.stressLevel=
        level;


    const source=
        safeString(
            entry.data.source
        );


    if(source){

        state.values.stressSource=
            source;


        setPattern(
            state,
            "stress_source_recorded",
            "stress",
            source
        );

    }


    if(level==="Low"){

        setPattern(
            state,
            "stress_low",
            "stress"
        );

    }


    if(level==="Moderate"){

        setPattern(
            state,
            "stress_moderate",
            "stress"
        );

    }


    if(level==="High"){

        setPattern(
            state,
            "stress_high",
            "stress"
        );

    }

}


/*==============================================================================*
*DERIVE MOOD PATTERNS
*==============================================================================*/

function deriveMoodPatterns(state){

    const entry=
        getLatest("mood");


    if(
        !entry ||
        !entry.data
    ){

        setPattern(
            state,
            "mood_not_logged",
            "mood"
        );

        return;

    }


    const mood=
        safeString(
            entry.data.mood
        );


    setPattern(
        state,
        "mood_recorded",
        "mood"
    );


    state.values.mood=
        mood;


    if(mood==="Good"){

        setPattern(
            state,
            "mood_good",
            "mood"
        );

    }


    if(mood==="Okay"){

        setPattern(
            state,
            "mood_okay",
            "mood"
        );

    }


    if(mood==="Low"){

        setPattern(
            state,
            "mood_low",
            "mood"
        );

    }

}


/*==============================================================================*
*DERIVE WATER PATTERNS
*==============================================================================*/

function deriveWaterPatterns(state){

    const entry=
        getLatest("water");


    if(
        !entry ||
        !entry.data
    ){

        setPattern(
            state,
            "water_not_logged",
            "water"
        );

        return;

    }


    const glasses=
        safeNumber(
            entry.data.glasses
        );


    setPattern(
        state,
        "water_logged",
        "water"
    );


    if(glasses!==null){

        setPattern(
            state,
            "water_glasses_reported",
            "water",
            glasses
        );


        state.values.waterGlasses=
            glasses;

    }

}


/*==============================================================================*
*DERIVE MEDICATION PATTERNS
*==============================================================================*/

function deriveMedicationPatterns(state){

    const entry=
        getLatest("medication");


    if(
        !entry ||
        !entry.data
    ){

        setPattern(
            state,
            "medication_not_logged",
            "medication"
        );

        return;

    }


    const status=
        safeString(
            entry.data.status
        );


    setPattern(
        state,
        "medication_status_recorded",
        "medication"
    );


    state.values.medicationStatus=
        status;


    state.values.medicationEventTime=
        safeString(
            entry.data.eventTime
        );


    if(status==="Taken"){

        setPattern(
            state,
            "medication_taken",
            "medication"
        );

    }


    if(status==="Missed"){

        setPattern(
            state,
            "medication_missed",
            "medication"
        );

    }


    if(status==="Not Applicable"){

        setPattern(
            state,
            "medication_not_applicable",
            "medication"
        );

    }

}


/*==============================================================================*
*DERIVE MOVEMENT PATTERNS
*==============================================================================*/

function deriveMovementPatterns(state){

    let entries=
        getHistory("movement");


    if(!entries.length){

        const latest=
            getLatest("movement");


        if(latest){

            entries=[latest];

        }

    }


    entries=
        entries.filter(

            function(entry){

                return(
                    entry &&
                    entry.data
                );

            }

        );


    if(!entries.length){

        setPattern(
            state,
            "movement_not_logged",
            "movement"
        );

        return;

    }


    setPattern(
        state,
        "movement_recorded",
        "movement"
    );


    const validEntries=
        entries.filter(

            function(entry){

                const minutes=
                    safeNumber(
                        entry.data.minutes
                    );


                return(
                    minutes!==null &&
                    minutes>0
                );

            }

        );


    const totalMinutes=
        validEntries.reduce(

            function(total,entry){

                return(
                    total+
                    safeNumber(
                        entry.data.minutes
                    )
                );

            },

            0

        );


    state.values.movementMinutes=
        totalMinutes;


    state.values.movementSessions=
        validEntries.length;


    setPattern(
        state,
        "movement_total_minutes",
        "movement",
        totalMinutes
    );


    if(validEntries.length>=2){

        setPattern(
            state,
            "multiple_movement_sessions",
            "movement",
            validEntries.length
        );

    }


    validEntries.forEach(

        function(entry){

            const activity=
                safeString(
                    entry.data.activity
                );


            if(activity==="Walking"){

                setPattern(
                    state,
                    "walking_recorded",
                    "movement"
                );

            }


            if(activity==="Exercise"){

                setPattern(
                    state,
                    "exercise_recorded",
                    "movement"
                );

            }


            if(activity==="Yoga"){

                setPattern(
                    state,
                    "yoga_recorded",
                    "movement"
                );

            }


            if(activity==="Other"){

                setPattern(
                    state,
                    "other_activity_recorded",
                    "movement"
                );

            }

        }

    );

}


/*==============================================================================*
*DERIVE MEAL PATTERNS
*==============================================================================*/

function deriveMealPatterns(state){

    let entries=
        getHistory("meal");


    if(!entries.length){

        const latest=
            getLatest("meal");


        if(latest){

            entries=[latest];

        }

    }


    entries=
        entries.filter(

            function(entry){

                return(
                    entry &&
                    entry.data
                );

            }

        );


    if(!entries.length){

        setPattern(
            state,
            "meal_not_logged",
            "meal"
        );

        return;

    }


    setPattern(
        state,
        "meal_recorded",
        "meal"
    );


    state.values.mealCount=
        entries.length;


    setPattern(
        state,
        "meal_count",
        "meal",
        entries.length
    );


    const timedMeals=
        entries.filter(

            function(entry){

                return isValidTimeValue(
                    entry.data.eventTime
                );

            }

        );


    if(timedMeals.length>=2){

        setPattern(
            state,
            "meal_sequence_available",
            "meal"
        );

    }


    const sortedTimed=
        sortByEventTime(
            timedMeals
        );


    if(sortedTimed.length){

        state.values.firstMealTime=
            sortedTimed[0].data.eventTime;


        state.values.lastMealTime=
            sortedTimed[
                sortedTimed.length-1
            ].data.eventTime;


        setPattern(
            state,
            "first_recorded_meal_time",
            "meal",
            state.values.firstMealTime
        );


        setPattern(
            state,
            "last_recorded_meal_time",
            "meal",
            state.values.lastMealTime
        );

    }


    entries.forEach(

        function(entry){

            const type=
                safeString(
                    entry.data.mealType
                );


            const food=
                safeString(
                    entry.data.food
                );


            if(type==="Breakfast"){

                setPattern(
                    state,
                    "breakfast_recorded",
                    "meal"
                );

            }


            if(type==="Lunch"){

                setPattern(
                    state,
                    "lunch_recorded",
                    "meal"
                );

            }


            if(type==="Dinner"){

                setPattern(
                    state,
                    "dinner_recorded",
                    "meal"
                );

            }


            if(type==="Snack"){

                setPattern(
                    state,
                    "snack_recorded",
                    "meal"
                );

            }


            if(food){

                setPattern(
                    state,
                    "meal_description_available",
                    "meal"
                );

            }

        }

    );


    deriveMealIntervals(
        state,
        sortedTimed
    );


    deriveLaterDinner(
        state,
        entries
    );

}


/*==============================================================================*
*DERIVE MEAL INTERVALS
*==============================================================================*/

function deriveMealIntervals(state,entries){

    if(
        !Array.isArray(entries) ||
        !entries.length
    ){

        return;

    }


    const breakfasts=
        entries.filter(

            function(entry){

                return(
                    safeString(
                        entry.data.mealType
                    )==="Breakfast"
                );

            }

        );


    const lunches=
        entries.filter(

            function(entry){

                return(
                    safeString(
                        entry.data.mealType
                    )==="Lunch"
                );

            }

        );


    const dinners=
        entries.filter(

            function(entry){

                return(
                    safeString(
                        entry.data.mealType
                    )==="Dinner"
                );

            }

        );


    /*==========================================================================
    BREAKFAST → LUNCH
    ==========================================================================*/

    if(
        breakfasts.length &&
        lunches.length
    ){

        const breakfast=
            breakfasts[
                breakfasts.length-1
            ];


        const breakfastMinutes=
            timeToMinutes(
                breakfast.data.eventTime
            );


        const lunch=
            lunches.find(

                function(entry){

                    const lunchMinutes=
                        timeToMinutes(
                            entry.data.eventTime
                        );


                    return(
                        lunchMinutes!==null &&
                        breakfastMinutes!==null &&
                        lunchMinutes>
                        breakfastMinutes
                    );

                }

            );


        if(lunch){

            const lunchMinutes=
                timeToMinutes(
                    lunch.data.eventTime
                );


            const interval=
                lunchMinutes-
                breakfastMinutes;


            state.values.breakfastLunchIntervalMinutes=
                interval;


            setPattern(
                state,
                "breakfast_to_lunch_interval",
                "meal",
                interval
            );


            if(interval>=330){

                setPattern(
                    state,
                    "long_recorded_meal_interval",
                    "meal",
                    interval
                );

            }

        }

    }


    /*==========================================================================
    LUNCH → DINNER
    ==========================================================================*/

    if(
        lunches.length &&
        dinners.length
    ){

        const lunch=
            lunches[
                lunches.length-1
            ];


        const lunchMinutes=
            timeToMinutes(
                lunch.data.eventTime
            );


        const dinner=
            dinners.find(

                function(entry){

                    const dinnerMinutes=
                        timeToMinutes(
                            entry.data.eventTime
                        );


                    return(
                        dinnerMinutes!==null &&
                        lunchMinutes!==null &&
                        dinnerMinutes>
                        lunchMinutes
                    );

                }

            );


        if(dinner){

            const dinnerMinutes=
                timeToMinutes(
                    dinner.data.eventTime
                );


            const interval=
                dinnerMinutes-
                lunchMinutes;


            state.values.lunchDinnerIntervalMinutes=
                interval;


            setPattern(
                state,
                "lunch_to_dinner_interval",
                "meal",
                interval
            );


            if(interval>=330){

                setPattern(
                    state,
                    "long_recorded_meal_interval",
                    "meal",
                    interval
                );

            }

        }

    }

}


/*==============================================================================*
*DERIVE LATER EVENING DINNER
*==============================================================================*/

function deriveLaterDinner(state,entries){

    entries.forEach(

        function(entry){

            if(
                safeString(
                    entry.data.mealType
                )!=="Dinner"
            ){

                return;

            }


            const minutes=
                timeToMinutes(
                    entry.data.eventTime
                );


            if(
                minutes!==null &&
                minutes>=1260
            ){

                setPattern(
                    state,
                    "later_evening_meal_recorded",
                    "meal",
                    entry.data.eventTime
                );

            }

        }

    );

}


/*==============================================================================*
*DERIVE BLOOD SUGAR PATTERNS
*==============================================================================*/

function deriveBloodSugarPatterns(state){

    let entries=
        getHistory(
            "bloodSugar"
        );


    if(!entries.length){

        const latest=
            getLatest(
                "bloodSugar"
            );


        if(latest){

            entries=[latest];

        }

    }


    entries=
        entries.filter(

            function(entry){

                return(
                    entry &&
                    entry.data &&
                    safeNumber(
                        entry.data.value
                    )!==null
                );

            }

        );


    if(!entries.length){

        setPattern(
            state,
            "bloodSugar_not_logged",
            "bloodSugar"
        );

        return;

    }


    setPattern(
        state,
        "glucose_reading_recorded",
        "bloodSugar"
    );


    state.values.glucoseReadingCount=
        entries.length;


    if(entries.length>=2){

        setPattern(
            state,
            "multiple_glucose_readings",
            "bloodSugar",
            entries.length
        );


        setPattern(
            state,
            "contextual_glucose_comparison_available",
            "bloodSugar"
        );

    }


    const contexts=
        entries
            .map(

                function(entry){

                    return safeString(
                        entry.data.context
                    );

                }

            )
            .filter(Boolean);


    const distinctContexts=
        countUnique(
            contexts
        );


    state.values.glucoseDistinctContexts=
        distinctContexts;


    if(distinctContexts>=2){

        setPattern(
            state,
            "glucose_readings_at_different_contexts",
            "bloodSugar",
            distinctContexts
        );

    }


    entries.forEach(

        function(entry){

            const context=
                safeString(
                    entry.data.context
                );


            if(context==="Fasting"){

                setPattern(
                    state,
                    "fasting_reading_available",
                    "bloodSugar"
                );

            }


            if(context==="Before Meal"){

                setPattern(
                    state,
                    "before_meal_reading_available",
                    "bloodSugar"
                );

            }


            if(context==="After Meal"){

                setPattern(
                    state,
                    "after_meal_reading_available",
                    "bloodSugar"
                );

            }


            if(context==="Random"){

                setPattern(
                    state,
                    "random_reading_available",
                    "bloodSugar"
                );

            }


            if(context==="Bedtime"){

                setPattern(
                    state,
                    "bedtime_reading_available",
                    "bloodSugar"
                );

            }

        }

    );


    deriveGlucoseChronology(
        state,
        entries
    );

}


/*==============================================================================*
*DERIVE GLUCOSE CHRONOLOGY
*==============================================================================*/

function deriveGlucoseChronology(
    state,
    entries
){

    const timed=
        entries.filter(

            function(entry){

                return isValidTimeValue(
                    entry.data.eventTime
                );

            }

        );


    const sorted=
        sortByEventTime(
            timed
        );


    if(sorted.length>=2){

        setPattern(
            state,
            "earlier_and_later_readings_available",
            "bloodSugar"
        );


        const first=
            sorted[0];


        const last=
            sorted[
                sorted.length-1
            ];


        const firstValue=
            safeNumber(
                first.data.value
            );


        const lastValue=
            safeNumber(
                last.data.value
            );


        if(
            firstValue!==null &&
            lastValue!==null
        ){

            state.values.firstGlucoseReading={

                value:firstValue,

                context:
                    safeString(
                        first.data.context
                    ),

                time:
                    safeString(
                        first.data.eventTime
                    )

            };


            state.values.lastGlucoseReading={

                value:lastValue,

                context:
                    safeString(
                        last.data.context
                    ),

                time:
                    safeString(
                        last.data.eventTime
                    )

            };


            if(lastValue>firstValue){

                setPattern(
                    state,
                    "later_reading_higher_than_earlier",
                    "bloodSugar",
                    lastValue-firstValue
                );

            }


            if(lastValue<firstValue){

                setPattern(
                    state,
                    "later_reading_lower_than_earlier",
                    "bloodSugar",
                    firstValue-lastValue
                );

            }


            if(lastValue===firstValue){

                setPattern(
                    state,
                    "readings_similar",
                    "bloodSugar",
                    0
                );

            }

        }

    }


    const values=
        entries
            .map(

                function(entry){

                    return safeNumber(
                        entry.data.value
                    );

                }

            )
            .filter(

                function(value){

                    return value!==null;

                }

            );


    if(values.length>=2){

        const highest=
            Math.max.apply(
                null,
                values
            );


        const lowest=
            Math.min.apply(
                null,
                values
            );


        const difference=
            highest-lowest;


        state.values.glucoseLargestDifference=
            difference;


        setPattern(
            state,
            "largest_recorded_difference",
            "bloodSugar",
            difference
        );

    }

}


/*==============================================================================*
*DERIVE CROSS PATTERNS
*==============================================================================*/

function deriveCrossPatterns(state){

    const addCrossPattern=
        function(id){

            if(
                !state.crossPatterns.includes(id)
            ){

                state.crossPatterns.push(id);

            }

        };


    /*==========================================================================
    SHORTER / POOR SLEEP + HIGH STRESS
    ==========================================================================*/

    if(
        (
            hasPattern(
                state,
                "clearly_shorter_sleep"
            ) ||
            hasPattern(
                state,
                "shorter_sleep"
            ) ||
            hasPattern(
                state,
                "sleep_quality_poor"
            )
        ) &&
        hasPattern(
            state,
            "stress_high"
        )
    ){

        addCrossPattern(
            "short_sleep_high_stress"
        );

    }


    /*==========================================================================
    SHORTER / POOR SLEEP + LOW MOOD
    ==========================================================================*/

    if(
        (
            hasPattern(
                state,
                "clearly_shorter_sleep"
            ) ||
            hasPattern(
                state,
                "shorter_sleep"
            ) ||
            hasPattern(
                state,
                "sleep_quality_poor"
            )
        ) &&
        hasPattern(
            state,
            "mood_low"
        )
    ){

        addCrossPattern(
            "short_sleep_low_mood"
        );

    }


    /*==========================================================================
    HIGH STRESS + LOW MOOD
    ==========================================================================*/

    if(
        hasPattern(
            state,
            "stress_high"
        ) &&
        hasPattern(
            state,
            "mood_low"
        )
    ){

        addCrossPattern(
            "high_stress_low_mood"
        );

    }


    /*==========================================================================
    MOVEMENT + HIGH STRESS
    ==========================================================================*/

    if(
        hasPattern(
            state,
            "movement_recorded"
        ) &&
        hasPattern(
            state,
            "stress_high"
        )
    ){

        addCrossPattern(
            "movement_with_high_stress"
        );

    }


    /*==========================================================================
    MOVEMENT + LOW MOOD
    ==========================================================================*/

    if(
        hasPattern(
            state,
            "movement_recorded"
        ) &&
        hasPattern(
            state,
            "mood_low"
        )
    ){

        addCrossPattern(
            "movement_with_low_mood"
        );

    }


    /*==========================================================================
    GOOD SLEEP + LOW STRESS
    ==========================================================================*/

    if(
        hasPattern(
            state,
            "sleep_quality_good"
        ) &&
        hasPattern(
            state,
            "stress_low"
        )
    ){

        addCrossPattern(
            "good_sleep_low_stress"
        );

    }


    /*==========================================================================
    GOOD MOOD + HIGH STRESS
    ==========================================================================*/

    if(
        hasPattern(
            state,
            "mood_good"
        ) &&
        hasPattern(
            state,
            "stress_high"
        )
    ){

        addCrossPattern(
            "good_mood_high_stress"
        );

    }

}


/*==============================================================================*
*CALCULATED FACTS
*==============================================================================*/

function buildCalculatedFacts(state){

    const facts={


        sleep:{

            hours:
                typeof state.values.sleepHours!=="undefined"
                    ? state.values.sleepHours
                    : null,

            quality:
                state.values.sleepQuality || ""

        },


        movement:{

            totalMinutes:
                typeof state.values.movementMinutes!=="undefined"
                    ? state.values.movementMinutes
                    : 0,

            sessions:
                typeof state.values.movementSessions!=="undefined"
                    ? state.values.movementSessions
                    : 0

        },


        water:{

            glasses:
                typeof state.values.waterGlasses!=="undefined"
                    ? state.values.waterGlasses
                    : null

        },


        meal:{

            count:
                typeof state.values.mealCount!=="undefined"
                    ? state.values.mealCount
                    : 0,

            firstTime:
                state.values.firstMealTime || "",

            lastTime:
                state.values.lastMealTime || "",

            breakfastLunchIntervalMinutes:
                typeof state.values.breakfastLunchIntervalMinutes!=="undefined"
                    ? state.values.breakfastLunchIntervalMinutes
                    : null,

            lunchDinnerIntervalMinutes:
                typeof state.values.lunchDinnerIntervalMinutes!=="undefined"
                    ? state.values.lunchDinnerIntervalMinutes
                    : null

        },


        bloodSugar:{

            readingCount:
                typeof state.values.glucoseReadingCount!=="undefined"
                    ? state.values.glucoseReadingCount
                    : 0,

            distinctContexts:
                typeof state.values.glucoseDistinctContexts!=="undefined"
                    ? state.values.glucoseDistinctContexts
                    : 0,

            first:
                state.values.firstGlucoseReading || null,

            last:
                state.values.lastGlucoseReading || null,

            largestDifference:
                typeof state.values.glucoseLargestDifference!=="undefined"
                    ? state.values.glucoseLargestDifference
                    : null

        },


        mood:{

            value:
                state.values.mood || ""

        },


        stress:{

            level:
                state.values.stressLevel || ""

        },


        medication:{

            status:
                state.values.medicationStatus || "",

            eventTime:
                state.values.medicationEventTime || ""

        }

    };


    return facts;

}


/*==============================================================================*
*BUILD DATA COVERAGE
*==============================================================================*/

function buildPatternCoverage(state){

    state.dataCoverage={

        checkinsLogged:
            countRecordedDomains(),

        bloodSugarReadings:
            getHistory(
                "bloodSugar"
            ).length ||
            (
                getLatest(
                    "bloodSugar"
                )
                    ? 1
                    : 0
            ),

        mealsRecorded:
            getHistory(
                "meal"
            ).length ||
            (
                getLatest(
                    "meal"
                )
                    ? 1
                    : 0
            ),

        movementSessions:
            getHistory(
                "movement"
            ).length ||
            (
                getLatest(
                    "movement"
                )
                    ? 1
                    : 0
            ),

        dataLevel:
            getDataCoverageLevel()

    };

}


/*==============================================================================*
*DERIVE ALL PATTERNS
*==============================================================================*/

function derivePatterns(){

    if(!todayW005){

        readTodayW005();

    }


    const state=
        createPatternState();


    deriveSleepPatterns(
        state
    );


    deriveStressPatterns(
        state
    );


    deriveMoodPatterns(
        state
    );


    deriveWaterPatterns(
        state
    );


    deriveMedicationPatterns(
        state
    );


    deriveMovementPatterns(
        state
    );


    deriveMealPatterns(
        state
    );


    deriveBloodSugarPatterns(
        state
    );


    deriveCrossPatterns(
        state
    );


    buildPatternCoverage(
        state
    );


    derivedPatterns=
        state;


    calculatedFacts=
        buildCalculatedFacts(
            state
        );


    return{

        patterns:
            clone(
                derivedPatterns
            ),

        facts:
            clone(
                calculatedFacts
            )

    };

}


/*==============================================================================*
*PUBLIC ENGINE API — EXTEND SECTION A EXPORT
*==============================================================================*/

window.TrestleW007Engine.getDerivedPatterns=
    function(){

        if(!todayW005){

            readEngineInputs();

        }


        if(!derivedPatterns){

            derivePatterns();

        }


        return clone(
            derivedPatterns
        );

    };


window.TrestleW007Engine.getCalculatedFacts=
    function(){

        if(!todayW005){

            readEngineInputs();

        }


        if(!derivedPatterns){

            derivePatterns();

        }


        return clone(
            calculatedFacts
        );

    };


window.TrestleW007Engine.hasPattern=
    function(id){

        if(!derivedPatterns){

            derivePatterns();

        }


        return hasPattern(
            derivedPatterns,
            id
        );

    };


/*==============================================================================*
*SECTION B END
*
*SECTION C CONTINUES DIRECTLY BELOW.
*
*DO NOT ADD })(); YET.
*==============================================================================*/
/*==============================================================================*
*SECTION C
*CONTEXT RELEVANCE ENGINE
*
*Combines:
*
*1. User Promise
*2. Life Stage
*3. Diabetes Profile
*4. Actual W005 derived patterns
*
*Purpose:
*
*Determine WHAT deserves attention.
*
*This section does NOT generate final report wording.
*==============================================================================*/


/*==============================================================================*
*CONTEXT RUNTIME
*==============================================================================*/

let relevanceContext=null;


/*==============================================================================*
*GET CURRENT PROFILE
*==============================================================================*/

function getCurrentProfile(){

    if(!profileContext){

        readProfileContext();

    }


    return profileContext || {

        promise:"",

        lifeStage:"",

        diabetesProfile:""

    };

}


/*==============================================================================*
*GET CURRENT PATTERN STATE
*==============================================================================*/

function getCurrentPatterns(){

    if(!derivedPatterns){

        derivePatterns();

    }


    return derivedPatterns ||
        createPatternState();

}


/*==============================================================================*
*NORMALIZE DOMAIN NAME
*==============================================================================*/

function normalizeDomain(value){

    const domain=
        safeString(value);


    const aliases={

        bloodsugar:"bloodSugar",

        blood_sugar:"bloodSugar",

        glucose:"bloodSugar",

        physicalactivity:"movement",

        physical_activity:"movement",

        activity:"movement",

        exercise:"movement",

        meals:"meal",

        nutrition:"meal",

        hydration:"water",

        medicines:"medication",

        medicine:"medication",

        meds:"medication"

    };


    const compact=
        domain
            .replace(/\s+/g,"")
            .toLowerCase();


    return aliases[compact] || domain;

}


/*==============================================================================*
*GET PROMISE RULE
*
*Section B of the Data file may expose Promise intelligence either as:
*
*promiseRules
*or
*promiseIntelligence
*
*The engine supports both safely.
*==============================================================================*/

function getPromiseRule(promise){

    if(
        !insightData ||
        !promise
    ){

        return null;

    }


    const sources=[

        insightData.promiseRules,

        insightData.promiseIntelligence

    ];


    for(
        let i=0;
        i<sources.length;
        i++
    ){

        const source=
            sources[i];


        if(
            !source ||
            typeof source!=="object"
        ){

            continue;

        }


        if(source[promise]){

            return source[promise];

        }


        const keys=
            Object.keys(source);


        const matchedKey=
            keys.find(

                function(key){

                    return(
                        key.toLowerCase()===
                        promise.toLowerCase()
                    );

                }

            );


        if(matchedKey){

            return source[matchedKey];

        }

    }


    return null;

}


/*==============================================================================*
*GET LIFE STAGE RULE
*==============================================================================*/

function getLifeStageRule(lifeStage){

    if(
        !insightData ||
        !lifeStage
    ){

        return null;

    }


    const sources=[

        insightData.lifeStageRules,

        insightData.lifeStageIntelligence

    ];


    for(
        let i=0;
        i<sources.length;
        i++
    ){

        const source=
            sources[i];


        if(
            !source ||
            typeof source!=="object"
        ){

            continue;

        }


        if(source[lifeStage]){

            return source[lifeStage];

        }


        const keys=
            Object.keys(source);


        const matchedKey=
            keys.find(

                function(key){

                    return(
                        key.toLowerCase()===
                        lifeStage.toLowerCase()
                    );

                }

            );


        if(matchedKey){

            return source[matchedKey];

        }

    }


    return null;

}


/*==============================================================================*
*GET DIABETES PROFILE RULE
*==============================================================================*/

function getDiabetesProfileRule(
    diabetesProfile
){

    if(
        !insightData ||
        !diabetesProfile ||
        !insightData.diabetesProfileRules
    ){

        return null;

    }


    if(
        insightData.diabetesProfileRules[
            diabetesProfile
        ]
    ){

        return(
            insightData.diabetesProfileRules[
                diabetesProfile
            ]
        );

    }


    const keys=
        Object.keys(
            insightData.diabetesProfileRules
        );


    const matchedKey=
        keys.find(

            function(key){

                return(
                    key.toLowerCase()===
                    diabetesProfile.toLowerCase()
                );

            }

        );


    return matchedKey
        ? insightData.diabetesProfileRules[
            matchedKey
        ]
        : null;

}


/*==============================================================================*
*BASE DOMAIN SCORES
*
*Small neutral starting values.
*
*These do not represent health scores.
*They are internal content-selection weights only.
*==============================================================================*/

function createBaseDomainScores(){

    return{

        sleep:0,

        movement:0,

        meal:0,

        water:0,

        bloodSugar:0,

        medication:0,

        mood:0,

        stress:0,

        general:0

    };

}


/*==============================================================================*
*ADD DOMAIN SCORE
*==============================================================================*/

function addDomainScore(
    scores,
    domain,
    amount
){

    domain=
        normalizeDomain(
            domain
        );


    if(
        !Object.prototype.hasOwnProperty.call(
            scores,
            domain
        )
    ){

        return;

    }


    const number=
        Number(amount);


    if(
        !Number.isFinite(number)
    ){

        return;

    }


    scores[domain]+=
        number;

}


/*==============================================================================*
*APPLY DOMAIN MAP
*
*Example:
*
*{
*   sleep:100,
*   movement:80
*}
*==============================================================================*/

function applyDomainMap(
    scores,
    map,
    multiplier
){

    if(
        !map ||
        typeof map!=="object"
    ){

        return;

    }


    const factor=
        Number.isFinite(
            Number(multiplier)
        )
            ? Number(multiplier)
            : 1;


    Object.keys(map).forEach(

        function(domain){

            const value=
                Number(
                    map[domain]
                );


            if(
                Number.isFinite(value)
            ){

                addDomainScore(

                    scores,

                    domain,

                    value*factor

                );

            }

        }

    );

}


/*==============================================================================*
*APPLY DOMAIN ARRAY
*
*Used when a rule supplies only ordered priority domains.
*==============================================================================*/

function applyDomainArray(
    scores,
    domains,
    startingWeight,
    step
){

    if(
        !Array.isArray(domains)
    ){

        return;

    }


    let weight=
        Number(startingWeight) || 0;


    const decrement=
        Number(step) || 0;


    domains.forEach(

        function(domain){

            addDomainScore(
                scores,
                domain,
                weight
            );


            weight=
                Math.max(
                    0,
                    weight-decrement
                );

        }

    );

}


/*==============================================================================*
*PROMISE DOMAIN SCORING
*
*Use configured Promise intelligence first.
*
*Fallback values exist only so the engine remains functional if Section B
*stores Promise intelligence as ordered domains rather than numeric weights.
*==============================================================================*/

function applyPromiseScores(
    scores,
    profile
){

    if(
        !profile ||
        !profile.promise
    ){

        return;

    }


    const rule=
        getPromiseRule(
            profile.promise
        );


    if(rule){

        if(
            rule.domainPriority &&
            typeof rule.domainPriority==="object"
        ){

            applyDomainMap(
                scores,
                rule.domainPriority,
                1
            );

            return;

        }


        if(
            rule.domainWeights &&
            typeof rule.domainWeights==="object"
        ){

            applyDomainMap(
                scores,
                rule.domainWeights,
                1
            );

            return;

        }


        if(
            Array.isArray(
                rule.priorityDomains
            )
        ){

            applyDomainArray(

                scores,

                rule.priorityDomains,

                110,

                12

            );

            return;

        }

    }


    /*==========================================================================
    SAFE FALLBACK
    ==========================================================================*/

    const fallback={


        "Balanced Life":{

            stress:105,

            sleep:100,

            movement:90,

            meal:75,

            mood:70,

            water:45

        },


        "More Energy":{

            sleep:110,

            movement:100,

            meal:80,

            stress:70,

            mood:55,

            water:45

        },


        "Better Sleep":{

            sleep:125,

            stress:85,

            movement:55,

            meal:45,

            mood:40

        },


        "More Calmness":{

            stress:125,

            sleep:90,

            mood:80,

            movement:65

        },


        "Better Focus":{

            sleep:110,

            stress:105,

            movement:70,

            meal:65,

            mood:55

        },


        "Healthier Living":{

            movement:110,

            sleep:95,

            meal:90,

            stress:70,

            water:55,

            mood:45

        }

    };


    applyDomainMap(

        scores,

        fallback[
            profile.promise
        ],

        1

    );

}


/*==============================================================================*
*LIFE STAGE DOMAIN SCORING
*
*Life Stage is a contextual modifier.
*
*It must NEVER overpower actual recorded evidence or create a diagnosis.
*==============================================================================*/

function applyLifeStageScores(
    scores,
    profile
){

    if(
        !profile ||
        !profile.lifeStage
    ){

        return;

    }


    const rule=
        getLifeStageRule(
            profile.lifeStage
        );


    if(!rule){

        return;

    }


    if(
        rule.domainPriority &&
        typeof rule.domainPriority==="object"
    ){

        applyDomainMap(
            scores,
            rule.domainPriority,
            0.60
        );

        return;

    }


    if(
        rule.domainWeights &&
        typeof rule.domainWeights==="object"
    ){

        applyDomainMap(
            scores,
            rule.domainWeights,
            0.60
        );

        return;

    }


    if(
        Array.isArray(
            rule.priorityDomains
        )
    ){

        applyDomainArray(

            scores,

            rule.priorityDomains,

            60,

            7

        );

    }

}


/*==============================================================================*
*DIABETES PROFILE DOMAIN SCORING
*==============================================================================*/

function applyDiabetesScores(
    scores,
    profile
){

    if(
        !profile ||
        !profile.diabetesProfile
    ){

        return;

    }


    const configuredMap=
        insightData &&
        insightData.diabetesProfileDomainPriority
            ? insightData
                .diabetesProfileDomainPriority[
                    profile.diabetesProfile
                ]
            : null;


    if(configuredMap){

        applyDomainMap(
            scores,
            configuredMap,
            0.70
        );

        return;

    }


    const rule=
        getDiabetesProfileRule(
            profile.diabetesProfile
        );


    if(
        rule &&
        Array.isArray(
            rule.priorityDomains
        )
    ){

        applyDomainArray(

            scores,

            rule.priorityDomains,

            70,

            8

        );

    }

}


/*==============================================================================*
*RECORDED EVIDENCE SCORING
*
*Profile context should never make an unrecorded domain look important in
*today's report.
*
*Recorded evidence receives a strong boost.
*Missing domains receive no evidence boost.
*==============================================================================*/

function applyEvidenceScores(
    scores,
    state
){

    if(!state){

        return;

    }


    const evidenceMap={


        sleep:[

            "sleep_recorded"

        ],


        movement:[

            "movement_recorded"

        ],


        meal:[

            "meal_recorded"

        ],


        water:[

            "water_logged"

        ],


        bloodSugar:[

            "glucose_reading_recorded"

        ],


        medication:[

            "medication_status_recorded"

        ],


        mood:[

            "mood_recorded"

        ],


        stress:[

            "stress_recorded"

        ]

    };


    Object.keys(
        evidenceMap
    ).forEach(

        function(domain){

            const supported=
                evidenceMap[domain].some(

                    function(patternId){

                        return hasPattern(
                            state,
                            patternId
                        );

                    }

                );


            if(supported){

                addDomainScore(
                    scores,
                    domain,
                    150
                );

            }

        }

    );


    /*==========================================================================
    STRONGER OBSERVATIONS
    ==========================================================================*/

    if(
        hasPattern(
            state,
            "sleep_quality_poor"
        )
    ){

        addDomainScore(
            scores,
            "sleep",
            35
        );

    }


    if(
        hasPattern(
            state,
            "clearly_shorter_sleep"
        )
    ){

        addDomainScore(
            scores,
            "sleep",
            40
        );

    }


    if(
        hasPattern(
            state,
            "stress_high"
        )
    ){

        addDomainScore(
            scores,
            "stress",
            40
        );

    }


    if(
        hasPattern(
            state,
            "medication_missed"
        )
    ){

        addDomainScore(
            scores,
            "medication",
            50
        );

    }


    if(
        hasPattern(
            state,
            "multiple_glucose_readings"
        )
    ){

        addDomainScore(
            scores,
            "bloodSugar",
            25
        );

    }


    if(
        hasPattern(
            state,
            "multiple_movement_sessions"
        )
    ){

        addDomainScore(
            scores,
            "movement",
            20
        );

    }


    if(
        hasPattern(
            state,
            "long_recorded_meal_interval"
        )
    ){

        addDomainScore(
            scores,
            "meal",
            20
        );

    }

}


/*==============================================================================*
*IS DOMAIN RECORDED
*==============================================================================*/

function isDomainRecorded(
    state,
    domain
){

    const map={

        sleep:"sleep_recorded",

        movement:"movement_recorded",

        meal:"meal_recorded",

        water:"water_logged",

        bloodSugar:"glucose_reading_recorded",

        medication:"medication_status_recorded",

        mood:"mood_recorded",

        stress:"stress_recorded"

    };


    if(domain==="general"){

        return true;

    }


    return Boolean(

        map[domain] &&
        hasPattern(
            state,
            map[domain]
        )

    );

}


/*==============================================================================*
*BUILD RANKED DOMAIN LIST
*==============================================================================*/

function buildRankedDomains(
    scores,
    state
){

    return Object.keys(scores)

        .map(

            function(domain){

                return{

                    domain:
                        domain,

                    score:
                        scores[domain],

                    recorded:
                        isDomainRecorded(
                            state,
                            domain
                        )

                };

            }

        )

        .sort(

            function(a,b){

                if(
                    a.recorded!==b.recorded
                ){

                    return(
                        a.recorded
                            ? -1
                            : 1
                    );

                }


                return(
                    b.score-
                    a.score
                );

            }

        );

}


/*==============================================================================*
*GET ACTIVE SAFETY MODE
*==============================================================================*/

function getActiveSafetyMode(
    profile
){

    if(
        !profile ||
        !profile.diabetesProfile
    ){

        return null;

    }


    const rule=
        getDiabetesProfileRule(
            profile.diabetesProfile
        );


    if(
        !rule ||
        !rule.safetyMode
    ){

        return null;

    }


    const safetyModes=
        insightData &&
        insightData.diabetesSafetyModes
            ? insightData.diabetesSafetyModes
            : {};


    return{

        id:
            rule.safetyMode,

        rules:
            safetyModes[
                rule.safetyMode
            ] || null

    };

}


/*==============================================================================*
*PROFILE COMBINATION MATCHER
*
*Checks special combinations such as:
*
*Pregnant + Gestational Diabetes
*Pregnant + Type 1
*Pregnant + Type 2
*Planning Pregnancy + Diabetes
*==============================================================================*/

function getProfileCombinationRule(
    profile
){

    if(
        !insightData ||
        !insightData
            .profileCombinationSafety ||
        !profile
    ){

        return null;

    }


    const rules=
        insightData
            .profileCombinationSafety;


    const keys=
        Object.keys(rules);


    for(
        let i=0;
        i<keys.length;
        i++
    ){

        const rule=
            rules[
                keys[i]
            ];


        if(!rule){

            continue;

        }


        if(
            rule.lifeStage &&
            rule.lifeStage!==
                profile.lifeStage
        ){

            continue;

        }


        if(
            rule.diabetesProfile &&
            rule.diabetesProfile!==
                profile.diabetesProfile
        ){

            continue;

        }


        if(
            Array.isArray(
                rule.diabetesProfileAny
            ) &&
            !rule.diabetesProfileAny.includes(
                profile.diabetesProfile
            )
        ){

            continue;

        }


        return{

            id:
                keys[i],

            rule:
                rule

        };

    }


    return null;

}


/*==============================================================================*
*GENERIC REQUIREMENT MATCHER
*
*Used by later sections to test rules in:
*
*Science
*Promise Reflection
*Tomorrow Focus
*Doctor Questions
*Contradictions
*==============================================================================*/

function ruleRequirementsMet(
    rule,
    state,
    profile
){

    if(!rule){

        return false;

    }


    state=
        state ||
        getCurrentPatterns();


    profile=
        profile ||
        getCurrentProfile();


    /*==========================================================================
    REQUIRED PATTERNS — ALL
    ==========================================================================*/

    if(
        Array.isArray(
            rule.requires
        )
    ){

        const allPresent=
            rule.requires.every(

                function(id){

                    return hasPattern(
                        state,
                        id
                    );

                }

            );


        if(!allPresent){

            return false;

        }

    }


    /*==========================================================================
    REQUIRED PATTERNS — ANY
    ==========================================================================*/

    if(
        Array.isArray(
            rule.requiresAny
        )
    ){

        const anyPresent=
            rule.requiresAny.some(

                function(id){

                    return hasPattern(
                        state,
                        id
                    );

                }

            );


        if(!anyPresent){

            return false;

        }

    }


    /*==========================================================================
    SPECIAL SLEEP ANY
    ==========================================================================*/

    if(
        Array.isArray(
            rule.requiresAnySleep
        )
    ){

        const anySleep=
            rule.requiresAnySleep.some(

                function(id){

                    return hasPattern(
                        state,
                        id
                    );

                }

            );


        if(!anySleep){

            return false;

        }

    }


    /*==========================================================================
    EXCLUDED PATTERNS
    ==========================================================================*/

    if(
        Array.isArray(
            rule.excludes
        )
    ){

        const excluded=
            rule.excludes.some(

                function(id){

                    return hasPattern(
                        state,
                        id
                    );

                }

            );


        if(excluded){

            return false;

        }

    }


    /*==========================================================================
    PROMISE
    ==========================================================================*/

    if(
        rule.promise &&
        rule.promise!==
            profile.promise
    ){

        return false;

    }


    if(
        Array.isArray(
            rule.promises
        ) &&
        !rule.promises.includes(
            profile.promise
        )
    ){

        return false;

    }


    /*==========================================================================
    LIFE STAGE
    ==========================================================================*/

    if(
        Array.isArray(
            rule.lifeStages
        ) &&
        !rule.lifeStages.includes(
            profile.lifeStage
        )
    ){

        return false;

    }


    /*==========================================================================
    DIABETES PROFILE
    ==========================================================================*/

    if(
        Array.isArray(
            rule.diabetesProfiles
        ) &&
        !rule.diabetesProfiles.includes(
            profile.diabetesProfile
        )
    ){

        return false;

    }


    /*==========================================================================
    PROFILE REQUIREMENTS OBJECT
    ==========================================================================*/

    if(
        rule.profileRequirements &&
        typeof rule.profileRequirements===
            "object"
    ){

        const requirements=
            rule.profileRequirements;


        if(
            Array.isArray(
                requirements.lifeStageAny
            ) &&
            !requirements
                .lifeStageAny
                .includes(
                    profile.lifeStage
                )
        ){

            return false;

        }


        if(
            Array.isArray(
                requirements.diabetesProfileAny
            ) &&
            !requirements
                .diabetesProfileAny
                .includes(
                    profile.diabetesProfile
                )
        ){

            return false;

        }

    }


    /*==========================================================================
    REQUIRES PROFILE ANY
    ==========================================================================*/

    if(
        rule.requiresProfileAny &&
        typeof rule.requiresProfileAny===
            "object"
    ){

        const requirements=
            rule.requiresProfileAny;


        if(
            Array.isArray(
                requirements.lifeStage
            ) &&
            !requirements
                .lifeStage
                .includes(
                    profile.lifeStage
                )
        ){

            return false;

        }


        if(
            Array.isArray(
                requirements.diabetesProfile
            ) &&
            !requirements
                .diabetesProfile
                .includes(
                    profile.diabetesProfile
                )
        ){

            return false;

        }

    }


    /*==========================================================================
    DATA COVERAGE LEVEL
    ==========================================================================*/

    if(
        Array.isArray(
            rule.requiresDataLevelAny
        )
    ){

        const level=
            state &&
            state.dataCoverage
                ? state
                    .dataCoverage
                    .dataLevel
                : "NONE";


        if(
            !rule
                .requiresDataLevelAny
                .includes(level)
        ){

            return false;

        }

    }


    return true;

}


/*==============================================================================*
*CALCULATE RULE SCORE
*
*Used later when several valid rules compete for one report slot.
*==============================================================================*/

function calculateRuleScore(
    rule,
    context
){

    if(!rule){

        return 0;

    }


    context=
        context ||
        relevanceContext;


    let score=
        Number(
            rule.priority
        ) || 0;


    if(
        context &&
        rule.domain
    ){

        const domain=
            normalizeDomain(
                rule.domain
            );


        score+=
            Number(
                context.domainScores[
                    domain
                ]
            ) || 0;

    }


    /*==========================================================================
    PROMISE MATCH BOOST
    ==========================================================================*/

    if(
        context &&
        context.profile &&
        context.profile.promise
    ){

        if(
            rule.promise===
                context.profile.promise
        ){

            score+=100;

        }


        if(
            Array.isArray(
                rule.promises
            ) &&
            rule.promises.includes(
                context.profile.promise
            )
        ){

            score+=60;

        }

    }


    /*==========================================================================
    LIFE STAGE MATCH BOOST
    ==========================================================================*/

    if(
        context &&
        context.profile &&
        Array.isArray(
            rule.lifeStages
        ) &&
        rule.lifeStages.includes(
            context.profile.lifeStage
        )
    ){

        score+=40;

    }


    /*==========================================================================
    DIABETES PROFILE MATCH BOOST
    ==========================================================================*/

    if(
        context &&
        context.profile &&
        Array.isArray(
            rule.diabetesProfiles
        ) &&
        rule.diabetesProfiles.includes(
            context.profile.diabetesProfile
        )
    ){

        score+=45;

    }


    /*==========================================================================
    PROFILE-SPECIFIC RULE BOOST
    ==========================================================================*/

    if(
        rule.profileRequirements ||
        rule.requiresProfileAny
    ){

        score+=50;

    }


    return score;

}


/*==============================================================================*
*GET ELIGIBLE RULES
*
*Accepts an object library:
*
*{
*   ruleA:{...},
*   ruleB:{...}
*}
*
*Returns matched rules ordered by relevance.
*==============================================================================*/

function getEligibleRules(
    library
){

    if(
        !library ||
        typeof library!=="object"
    ){

        return[];

    }


    const state=
        getCurrentPatterns();


    const profile=
        getCurrentProfile();


    return Object.keys(library)

        .map(

            function(key){

                return{

                    key:
                        key,

                    rule:
                        library[key]

                };

            }

        )

        .filter(

            function(item){

                return(
                    item.rule &&
                    item.rule.active!==false &&
                    ruleRequirementsMet(
                        item.rule,
                        state,
                        profile
                    )
                );

            }

        )

        .map(

            function(item){

                return{

                    key:
                        item.key,

                    rule:
                        item.rule,

                    score:
                        calculateRuleScore(
                            item.rule
                        )

                };

            }

        )

        .sort(

            function(a,b){

                return(
                    b.score-
                    a.score
                );

            }

        );

}


/*==============================================================================*
*BUILD RELEVANCE CONTEXT
*==============================================================================*/

function buildRelevanceContext(){

    if(!insightData){

        loadInsightData();

    }


    if(!profileContext){

        readProfileContext();

    }


    if(!todayW005){

        readTodayW005();

    }


    if(!derivedPatterns){

        derivePatterns();

    }


    const profile=
        getCurrentProfile();


    const state=
        getCurrentPatterns();


    const scores=
        createBaseDomainScores();


    /*==========================================================================
    1. PROMISE
    ==========================================================================*/

    applyPromiseScores(
        scores,
        profile
    );


    /*==========================================================================
    2. LIFE STAGE
    ==========================================================================*/

    applyLifeStageScores(
        scores,
        profile
    );


    /*==========================================================================
    3. DIABETES PROFILE
    ==========================================================================*/

    applyDiabetesScores(
        scores,
        profile
    );


    /*==========================================================================
    4. ACTUAL RECORDED EVIDENCE
    ==========================================================================*/

    applyEvidenceScores(
        scores,
        state
    );


    const rankedDomains=
        buildRankedDomains(
            scores,
            state
        );


    const safetyMode=
        getActiveSafetyMode(
            profile
        );


    const combinationRule=
        getProfileCombinationRule(
            profile
        );


    relevanceContext={

        profile:
            clone(
                profile
            ),

        domainScores:
            clone(
                scores
            ),

        rankedDomains:
            clone(
                rankedDomains
            ),

        primaryRecordedDomain:
            (
                rankedDomains.find(

                    function(item){

                        return(
                            item.recorded &&
                            item.domain!=="general"
                        );

                    }

                ) || {}
            ).domain || "",

        safetyMode:
            clone(
                safetyMode
            ),

        profileCombination:
            clone(
                combinationRule
            ),

        dataCoverage:
            clone(
                state.dataCoverage
            )

    };


    return clone(
        relevanceContext
    );

}


/*==============================================================================*
*GET DOMAIN SCORE
*==============================================================================*/

function getDomainScore(domain){

    if(!relevanceContext){

        buildRelevanceContext();

    }


    domain=
        normalizeDomain(
            domain
        );


    return(
        relevanceContext &&
        relevanceContext.domainScores
            ? Number(
                relevanceContext
                    .domainScores[
                        domain
                    ]
            ) || 0
            : 0
    );

}


/*==============================================================================*
*GET RANKED RECORDED DOMAINS
*==============================================================================*/

function getRankedRecordedDomains(){

    if(!relevanceContext){

        buildRelevanceContext();

    }


    return clone(

        relevanceContext
            .rankedDomains
            .filter(

                function(item){

                    return(
                        item.recorded &&
                        item.domain!=="general"
                    );

                }

            )

    );

}


/*==============================================================================*
*CHECK IF SCIENCE DOMAIN IS ALLOWED FOR DIABETES PROFILE
*==============================================================================*/

function isScienceDomainAllowed(
    domain
){

    const profile=
        getCurrentProfile();


    const diabetesRule=
        getDiabetesProfileRule(
            profile.diabetesProfile
        );


    if(!diabetesRule){

        return true;

    }


    domain=
        normalizeDomain(
            domain
        );


    if(
        Array.isArray(
            diabetesRule
                .allowedReferenceDomains
        )
    ){

        return(
            diabetesRule
                .allowedReferenceDomains
                .includes(domain)
        );

    }


    return true;

}


/*==============================================================================*
*GET ACTIVE PROFILE SAFETY
*
*Convenience object for later composer sections.
*==============================================================================*/

function getActiveProfileSafety(){

    if(!relevanceContext){

        buildRelevanceContext();

    }


    return{

        diabetesSafetyMode:
            clone(
                relevanceContext
                    .safetyMode
            ),

        profileCombination:
            clone(
                relevanceContext
                    .profileCombination
            )

    };

}


/*==============================================================================*
*PUBLIC ENGINE API — SECTION C
*==============================================================================*/

window.TrestleW007Engine.getRelevanceContext=
    function(){

        return clone(
            buildRelevanceContext()
        );

    };


window.TrestleW007Engine.getRankedDomains=
    function(){

        if(!relevanceContext){

            buildRelevanceContext();

        }


        return clone(
            relevanceContext.rankedDomains
        );

    };


window.TrestleW007Engine.getRankedRecordedDomains=
    function(){

        return getRankedRecordedDomains();

    };


window.TrestleW007Engine.getDomainScore=
    function(domain){

        return getDomainScore(
            domain
        );

    };


window.TrestleW007Engine.getEligibleRules=
    function(library){

        if(!relevanceContext){

            buildRelevanceContext();

        }


        return clone(
            getEligibleRules(
                library
            )
        );

    };


window.TrestleW007Engine.getProfileSafety=
    function(){

        return clone(
            getActiveProfileSafety()
        );

    };


/*==============================================================================*
*SECTION C END
*
*SECTION D CONTINUES DIRECTLY BELOW.
*
*DO NOT ADD })(); YET.
*==============================================================================*/
/*==============================================================================*
*SECTION D
*YOUR DAY AT A GLANCE GENERATOR
*
*Purpose:
*
*Convert today's normalized W005 facts into a factual visual/report-ready object.
*
*This section:
*
*1. Does NOT diagnose.
*2. Does NOT compare against health targets.
*3. Does NOT interpret causation.
*4. Uses only what the user actually recorded.
*==============================================================================*/


/*==============================================================================*
*DAY AT A GLANCE RUNTIME
*==============================================================================*/

let dayAtGlanceData=null;


/*==============================================================================*
*STABLE VARIANT SELECTOR
*
*W007 should not randomly change wording every time a function runs.
*
*Selection is deterministic for:
*
*date + rule key
*==============================================================================*/

function chooseStableVariant(
    variants,
    key
){

    if(
        !Array.isArray(variants) ||
        !variants.length
    ){

        return"";

    }


    if(variants.length===1){

        return safeString(
            variants[0]
        );

    }


    const seed=
        (
            getTodayKey()+
            "|" +
            safeString(key)
        );


    let hash=0;


    for(
        let i=0;
        i<seed.length;
        i++
    ){

        hash=
            (
                (
                    hash<<5
                ) -
                hash
            ) +
            seed.charCodeAt(i);


        hash=
            hash|0;

    }


    const index=
        Math.abs(hash) %
        variants.length;


    return safeString(
        variants[index]
    );

}


/*==============================================================================*
*TEMPLATE REPLACER
*==============================================================================*/

function fillTemplate(
    template,
    values
){

    let output=
        safeString(
            template
        );


    if(
        !values ||
        typeof values!=="object"
    ){

        return output;

    }


    Object.keys(values).forEach(

        function(key){

            const token=
                new RegExp(
                    "\\{" +
                    key +
                    "\\}",
                    "g"
                );


            output=
                output.replace(
                    token,
                    String(
                        values[key]
                    )
                );

        }

    );


    return output;

}


/*==============================================================================*
*NUMBER DISPLAY
*==============================================================================*/

function formatNumber(value){

    const number=
        safeNumber(value);


    if(number===null){

        return"";

    }


    if(
        Number.isInteger(number)
    ){

        return String(number);

    }


    return String(
        Math.round(
            number*10
        )/10
    );

}


/*==============================================================================*
*FORMAT MINUTES AS INTERVAL
*
*Examples:
*
*330 → 5 hr 30 min
*360 → 6 hr
*==============================================================================*/

function formatDurationMinutes(
    minutes
){

    const value=
        safeNumber(
            minutes
        );


    if(
        value===null ||
        value<0
    ){

        return"";

    }


    const hours=
        Math.floor(
            value/60
        );


    const mins=
        Math.round(
            value%60
        );


    if(
        hours>0 &&
        mins>0
    ){

        return(
            hours+
            " hr " +
            mins+
            " min"
        );

    }


    if(hours>0){

        return(
            hours+
            (
                hours===1
                    ? " hr"
                    : " hrs"
            )
        );

    }


    return(
        mins+
        " min"
    );

}


/*==============================================================================*
*PLURAL HELPERS
*==============================================================================*/

function pluralS(value){

    return(
        Number(value)===1
            ? ""
            : "s"
    );

}


function entryWord(value){

    return(
        Number(value)===1
            ? "entry"
            : "entries"
    );

}


/*==============================================================================*
*GET DAY AT GLANCE RULE
*==============================================================================*/

function getDayAtGlanceRule(
    key
){

    if(
        !insightData ||
        !insightData.dayAtGlanceRules
    ){

        return null;

    }


    return(
        insightData
            .dayAtGlanceRules[
                key
            ] ||
        null
    );

}


/*==============================================================================*
*BUILD SLEEP SNAPSHOT
*==============================================================================*/

function buildSleepSnapshot(
    state,
    facts
){

    if(
        !hasPattern(
            state,
            "sleep_recorded"
        )
    ){

        return null;

    }


    const hours=
        facts &&
        facts.sleep
            ? safeNumber(
                facts.sleep.hours
            )
            : null;


    const quality=
        facts &&
        facts.sleep
            ? safeString(
                facts.sleep.quality
            )
            : "";


    const rule=
        getDayAtGlanceRule(
            "sleepSummary"
        );


    let text="";


    if(
        rule &&
        Array.isArray(
            rule.variants
        )
    ){

        const template=
            chooseStableVariant(

                rule.variants,

                "day_glance_sleep"

            );


        text=
            fillTemplate(

                template,

                {

                    hours:
                        hours!==null
                            ? formatNumber(
                                hours
                            )
                            : "—",

                    quality:
                        quality ||
                        "Not specified"

                }

            );

    }


    return{

        domain:"sleep",

        label:"Sleep",

        available:true,

        hours:
            hours,

        quality:
            quality,

        displayValue:

            (
                hours!==null

                    ? formatNumber(
                        hours
                    ) +
                      " hrs"

                    : ""
            ) +

            (
                quality

                    ? (
                        hours!==null
                            ? " · "
                            : ""
                    ) +
                      quality

                    : ""
            ),

        summary:
            text

    };

}


/*==============================================================================*
*BUILD MOVEMENT SNAPSHOT
*==============================================================================*/

function buildMovementSnapshot(
    state,
    facts
){

    if(
        !hasPattern(
            state,
            "movement_recorded"
        )
    ){

        return null;

    }


    const minutes=
        facts &&
        facts.movement
            ? safeNumber(
                facts.movement.totalMinutes
            )
            : null;


    const sessions=
        facts &&
        facts.movement
            ? safeNumber(
                facts.movement.sessions
            )
            : null;


    const history=
        getHistory(
            "movement"
        );


    const activities=
        history

            .map(

                function(entry){

                    return(
                        entry &&
                        entry.data
                            ? safeString(
                                entry.data.activity
                            )
                            : ""
                    );

                }

            )

            .filter(Boolean);


    const uniqueActivities=
        Array.from(
            new Set(
                activities
            )
        );


    const rule=
        getDayAtGlanceRule(
            "movementSummary"
        );


    let text="";


    if(
        rule &&
        Array.isArray(
            rule.variants
        )
    ){

        const template=
            chooseStableVariant(

                rule.variants,

                "day_glance_movement"

            );


        text=
            fillTemplate(

                template,

                {

                    minutes:
                        minutes!==null
                            ? formatNumber(
                                minutes
                            )
                            : "0",

                    sessions:
                        sessions!==null
                            ? formatNumber(
                                sessions
                            )
                            : "0",

                    sessionPlural:
                        pluralS(
                            sessions
                        )

                }

            );

    }


    return{

        domain:"movement",

        label:"Movement",

        available:true,

        minutes:
            minutes,

        sessions:
            sessions,

        activities:
            uniqueActivities,

        displayValue:

            (
                minutes!==null
                    ? formatNumber(
                        minutes
                    ) +
                      " min"
                    : ""
            ),

        secondaryDisplay:

            sessions!==null
                ? (
                    sessions+
                    " session"+
                    pluralS(
                        sessions
                    )
                )
                : "",

        summary:
            text

    };

}


/*==============================================================================*
*BUILD WATER SNAPSHOT
*==============================================================================*/

function buildWaterSnapshot(
    state,
    facts
){

    if(
        !hasPattern(
            state,
            "water_logged"
        )
    ){

        return null;

    }


    const glasses=
        facts &&
        facts.water
            ? safeNumber(
                facts.water.glasses
            )
            : null;


    const rule=
        getDayAtGlanceRule(
            "waterSummary"
        );


    let text="";


    if(
        rule &&
        Array.isArray(
            rule.variants
        )
    ){

        const template=
            chooseStableVariant(

                rule.variants,

                "day_glance_water"

            );


        text=
            fillTemplate(

                template,

                {

                    glasses:
                        glasses!==null
                            ? formatNumber(
                                glasses
                            )
                            : "0",

                    glassPlural:
                        pluralS(
                            glasses
                        )

                }

            );

    }


    return{

        domain:"water",

        label:"Water",

        available:true,

        glasses:
            glasses,

        displayValue:

            glasses!==null

                ? (
                    formatNumber(
                        glasses
                    ) +
                    " glass" +
                    pluralS(
                        glasses
                    )
                )

                : "",

        target:
            null,

        percentage:
            null,

        summary:
            text

    };

}


/*==============================================================================*
*BUILD MEAL TIMELINE
*==============================================================================*/

function buildMealTimeline(){

    const history=
        sortByEventTime(
            getHistory(
                "meal"
            )
        );


    return history

        .filter(

            function(entry){

                return(
                    entry &&
                    entry.data
                );

            }

        )

        .map(

            function(entry){

                const data=
                    entry.data;


                return{

                    type:
                        safeString(
                            data.mealType
                        ) ||
                        "Meal",

                    time:
                        safeString(
                            data.eventTime
                        ),

                    displayTime:
                        formatEventTime(
                            data.eventTime
                        ),

                    food:
                        safeString(
                            data.food
                        )

                };

            }

        );

}


/*==============================================================================*
*BUILD MEAL SNAPSHOT
*==============================================================================*/

function buildMealSnapshot(
    state,
    facts
){

    if(
        !hasPattern(
            state,
            "meal_recorded"
        )
    ){

        return null;

    }


    const timeline=
        buildMealTimeline();


    const count=
        timeline.length ||
        (
            facts &&
            facts.meal
                ? safeNumber(
                    facts.meal.count
                )
                : 0
        );


    const rule=
        getDayAtGlanceRule(
            "mealSummary"
        );


    let text="";


    if(
        rule &&
        Array.isArray(
            rule.variants
        )
    ){

        const template=
            chooseStableVariant(

                rule.variants,

                "day_glance_meal"

            );


        /*
        Section G originally used:
        entr{entryPlural}

        We provide:
        y / ies
        */

        const entryPlural=

            Number(count)===1
                ? "y"
                : "ies";


        text=
            fillTemplate(

                template,

                {

                    count:
                        count,

                    entryPlural:
                        entryPlural

                }

            );

    }


    return{

        domain:"meal",

        label:"Meals",

        available:true,

        count:
            count,

        timeline:
            timeline,

        firstTime:

            facts &&
            facts.meal
                ? safeString(
                    facts.meal.firstTime
                )
                : "",

        lastTime:

            facts &&
            facts.meal
                ? safeString(
                    facts.meal.lastTime
                )
                : "",

        breakfastLunchIntervalMinutes:

            facts &&
            facts.meal
                ? safeNumber(
                    facts.meal
                        .breakfastLunchIntervalMinutes
                )
                : null,

        lunchDinnerIntervalMinutes:

            facts &&
            facts.meal
                ? safeNumber(
                    facts.meal
                        .lunchDinnerIntervalMinutes
                )
                : null,

        displayValue:

            count+
            " " +
            entryWord(
                count
            ),

        summary:
            text

    };

}


/*==============================================================================*
*BUILD BLOOD SUGAR TIMELINE
*==============================================================================*/

function buildBloodSugarTimeline(){

    let history=
        getHistory(
            "bloodSugar"
        );


    if(!history.length){

        const latest=
            getLatest(
                "bloodSugar"
            );


        if(latest){

            history=[latest];

        }

    }


    return sortByEventTime(
        history
    )

        .filter(

            function(entry){

                return(
                    entry &&
                    entry.data &&
                    safeNumber(
                        entry.data.value
                    )!==null
                );

            }

        )

        .map(

            function(entry){

                const data=
                    entry.data;


                return{

                    value:
                        safeNumber(
                            data.value
                        ),

                    unit:
                        safeString(
                            data.unit
                        ) ||
                        "mg/dL",

                    context:
                        safeString(
                            data.context
                        ),

                    time:
                        safeString(
                            data.eventTime
                        ),

                    displayTime:
                        formatEventTime(
                            data.eventTime
                        )

                };

            }

        );

}


/*==============================================================================*
*BUILD BLOOD SUGAR SNAPSHOT
*==============================================================================*/

function buildBloodSugarSnapshot(
    state
){

    if(
        !hasPattern(
            state,
            "glucose_reading_recorded"
        )
    ){

        return null;

    }


    const readings=
        buildBloodSugarTimeline();


    const count=
        readings.length;


    const contexts=
        Array.from(

            new Set(

                readings

                    .map(

                        function(item){

                            return item.context;

                        }

                    )

                    .filter(Boolean)

            )

        );


    const rule=
        getDayAtGlanceRule(
            "bloodSugarSummary"
        );


    let text="";


    if(
        rule &&
        Array.isArray(
            rule.variants
        )
    ){

        const template=
            chooseStableVariant(

                rule.variants,

                "day_glance_glucose"

            );


        text=
            fillTemplate(

                template,

                {

                    count:
                        count,

                    plural:
                        pluralS(
                            count
                        )

                }

            );

    }


    return{

        domain:"bloodSugar",

        label:"Blood Sugar",

        available:true,

        count:
            count,

        contexts:
            contexts,

        readings:
            readings,

        displayValue:

            count+
            " reading"+
            pluralS(
                count
            ),

        grading:
            null,

        target:
            null,

        summary:
            text

    };

}


/*==============================================================================*
*BUILD MOOD SNAPSHOT
*==============================================================================*/

function buildMoodSnapshot(
    state,
    facts
){

    if(
        !hasPattern(
            state,
            "mood_recorded"
        )
    ){

        return null;

    }


    const mood=
        facts &&
        facts.mood
            ? safeString(
                facts.mood.value
            )
            : "";


    const rule=
        getDayAtGlanceRule(
            "moodSummary"
        );


    let text="";


    if(
        rule &&
        Array.isArray(
            rule.variants
        )
    ){

        text=
            fillTemplate(

                chooseStableVariant(

                    rule.variants,

                    "day_glance_mood"

                ),

                {
                    mood:
                        mood
                }

            );

    }


    return{

        domain:"mood",

        label:"Mood",

        available:true,

        value:
            mood,

        displayValue:
            mood,

        summary:
            text

    };

}


/*==============================================================================*
*BUILD STRESS SNAPSHOT
*==============================================================================*/

function buildStressSnapshot(
    state,
    facts
){

    if(
        !hasPattern(
            state,
            "stress_recorded"
        )
    ){

        return null;

    }


    const level=
        facts &&
        facts.stress
            ? safeString(
                facts.stress.level
            )
            : "";


    const rule=
        getDayAtGlanceRule(
            "stressSummary"
        );


    let text="";


    if(
        rule &&
        Array.isArray(
            rule.variants
        )
    ){

        text=
            fillTemplate(

                chooseStableVariant(

                    rule.variants,

                    "day_glance_stress"

                ),

                {
                    level:
                        level
                }

            );

    }


    return{

        domain:"stress",

        label:"Stress",

        available:true,

        value:
            level,

        displayValue:
            level,

        summary:
            text

    };

}


/*==============================================================================*
*BUILD MEDICATION SNAPSHOT
*==============================================================================*/

function buildMedicationSnapshot(
    state,
    facts
){

    if(
        !hasPattern(
            state,
            "medication_status_recorded"
        )
    ){

        return null;

    }


    const status=
        facts &&
        facts.medication
            ? safeString(
                facts.medication.status
            )
            : "";


    const eventTime=
        facts &&
        facts.medication
            ? safeString(
                facts.medication.eventTime
            )
            : "";


    const rule=
        getDayAtGlanceRule(
            "medicationSummary"
        );


    let text="";


    if(
        rule &&
        Array.isArray(
            rule.variants
        )
    ){

        text=
            fillTemplate(

                chooseStableVariant(

                    rule.variants,

                    "day_glance_medication"

                ),

                {
                    status:
                        status
                }

            );

    }


    return{

        domain:"medication",

        label:"Medication",

        available:true,

        status:
            status,

        eventTime:
            eventTime,

        displayTime:
            formatEventTime(
                eventTime
            ),

        displayValue:
            status,

        summary:
            text

    };

}


/*==============================================================================*
*BUILD FACTUAL OBSERVATIONS
*
*These may later be used by the composer.
*
*No health judgement is included.
*==============================================================================*/

function buildFactualObservations(
    state,
    facts
){

    const observations=[];


    /*==========================================================================
    MEAL INTERVAL
    ==========================================================================*/

    if(
        hasPattern(
            state,
            "breakfast_to_lunch_interval"
        ) &&
        facts &&
        facts.meal &&
        facts.meal
            .breakfastLunchIntervalMinutes!==null
    ){

        observations.push({

            id:
                "fact_breakfast_lunch_interval",

            domain:
                "meal",

            evidenceClass:
                "B",

            text:

                "There were " +
                formatDurationMinutes(

                    facts.meal
                        .breakfastLunchIntervalMinutes

                ) +
                " between the breakfast and lunch you recorded."

        });

    }


    /*==========================================================================
    LUNCH → DINNER INTERVAL
    ==========================================================================*/

    if(
        hasPattern(
            state,
            "lunch_to_dinner_interval"
        ) &&
        facts &&
        facts.meal &&
        facts.meal
            .lunchDinnerIntervalMinutes!==null
    ){

        observations.push({

            id:
                "fact_lunch_dinner_interval",

            domain:
                "meal",

            evidenceClass:
                "B",

            text:

                "There were " +
                formatDurationMinutes(

                    facts.meal
                        .lunchDinnerIntervalMinutes

                ) +
                " between the lunch and dinner you recorded."

        });

    }


    /*==========================================================================
    MULTIPLE GLUCOSE CONTEXTS
    ==========================================================================*/

    if(
        hasPattern(
            state,
            "glucose_readings_at_different_contexts"
        )
    ){

        const snapshot=
            buildBloodSugarSnapshot(
                state
            );


        if(
            snapshot &&
            snapshot.contexts.length
        ){

            observations.push({

                id:
                    "fact_glucose_contexts",

                domain:
                    "bloodSugar",

                evidenceClass:
                    "B",

                text:

                    "You recorded glucose in " +
                    snapshot.contexts.length +
                    " different context" +
                    pluralS(
                        snapshot.contexts.length
                    ) +
                    ": " +
                    snapshot.contexts.join(
                        ", "
                    ) +
                    "."

            });

        }

    }


    /*==========================================================================
    MULTIPLE MOVEMENT SESSIONS
    ==========================================================================*/

    if(
        hasPattern(
            state,
            "multiple_movement_sessions"
        ) &&
        facts &&
        facts.movement
    ){

        observations.push({

            id:
                "fact_multiple_movement",

            domain:
                "movement",

            evidenceClass:
                "B",

            text:

                "You recorded movement " +
                facts.movement.sessions +
                " times today, adding up to " +
                formatNumber(
                    facts.movement.totalMinutes
                ) +
                " minutes."

        });

    }


    return observations;

}


/*==============================================================================*
*BUILD DAY AT A GLANCE
*==============================================================================*/

function buildDayAtGlance(){

    if(!derivedPatterns){

        derivePatterns();

    }


    if(!calculatedFacts){

        calculatedFacts=
            buildCalculatedFacts(
                derivedPatterns
            );

    }


    const state=
        derivedPatterns;


    const facts=
        calculatedFacts;


    const items={};


    const sleep=
        buildSleepSnapshot(
            state,
            facts
        );


    const movement=
        buildMovementSnapshot(
            state,
            facts
        );


    const water=
        buildWaterSnapshot(
            state,
            facts
        );


    const meal=
        buildMealSnapshot(
            state,
            facts
        );


    const bloodSugar=
        buildBloodSugarSnapshot(
            state
        );


    const mood=
        buildMoodSnapshot(
            state,
            facts
        );


    const stress=
        buildStressSnapshot(
            state,
            facts
        );


    const medication=
        buildMedicationSnapshot(
            state,
            facts
        );


    if(sleep){

        items.sleep=
            sleep;

    }


    if(movement){

        items.movement=
            movement;

    }


    if(water){

        items.water=
            water;

    }


    if(meal){

        items.meal=
            meal;

    }


    if(bloodSugar){

        items.bloodSugar=
            bloodSugar;

    }


    if(mood){

        items.mood=
            mood;

    }


    if(stress){

        items.stress=
            stress;

    }


    if(medication){

        items.medication=
            medication;

    }


    /*==========================================================================
    DISPLAY ORDER
    ==========================================================================*/

    const preferredOrder=

        insightData &&
        Array.isArray(
            insightData.dayAtGlanceOrder
        )

            ? insightData.dayAtGlanceOrder

            : [

                "sleep",

                "movement",

                "water",

                "meal",

                "bloodSugar",

                "mood",

                "stress",

                "medication"

            ];


    const orderedItems=[];


    preferredOrder.forEach(

        function(domain){

            if(items[domain]){

                orderedItems.push(
                    items[domain]
                );

            }

        }

    );


    /*==========================================================================
    INTRO
    ==========================================================================*/

    let intro=
        "Here's what you chose to record today.";


    if(
        insightData &&
        insightData.dayAtGlanceRules &&
        Array.isArray(
            insightData
                .dayAtGlanceRules
                .introVariants
        )
    ){

        intro=
            chooseStableVariant(

                insightData
                    .dayAtGlanceRules
                    .introVariants,

                "day_glance_intro"

            ) ||
            intro;

    }


    dayAtGlanceData={

        intro:
            intro,

        itemCount:
            orderedItems.length,

        items:
            orderedItems,

        factualObservations:
            buildFactualObservations(
                state,
                facts
            ),

        mealTimeline:
            meal
                ? clone(
                    meal.timeline
                )
                : [],

        bloodSugarTimeline:
            bloodSugar
                ? clone(
                    bloodSugar.readings
                )
                : []

    };


    return clone(
        dayAtGlanceData
    );

}


/*==============================================================================*
*GET DAY AT GLANCE DOMAIN
*==============================================================================*/

function getDayAtGlanceDomain(
    domain
){

    if(!dayAtGlanceData){

        buildDayAtGlance();

    }


    domain=
        normalizeDomain(
            domain
        );


    const item=
        dayAtGlanceData.items.find(

            function(entry){

                return(
                    entry.domain===
                    domain
                );

            }

        );


    return item
        ? clone(item)
        : null;

}


/*==============================================================================*
*PUBLIC ENGINE API — SECTION D
*==============================================================================*/

window.TrestleW007Engine.getDayAtGlance=
    function(){

        if(!todayW005){

            readEngineInputs();

        }


        return clone(
            buildDayAtGlance()
        );

    };


window.TrestleW007Engine.getDayAtGlanceDomain=
    function(domain){

        return getDayAtGlanceDomain(
            domain
        );

    };


/*==============================================================================*
*SECTION D END
*
*SECTION E CONTINUES DIRECTLY BELOW.
*
*DO NOT ADD })(); YET.
*==============================================================================*/
/*==============================================================================*
*SECTION E
*SCIENCE & YOUR DAY GENERATOR
*
*Purpose:
*
*Select at most TWO scientifically valid contextual references based on:
*
*1. Actual recorded data
*2. Promise relevance
*3. Life Stage
*4. Diabetes Profile
*5. Safety rules
*
*This section does NOT turn general guidance into personal medical targets.
*==============================================================================*/


/*==============================================================================*
*SCIENCE RUNTIME
*==============================================================================*/

let scienceAndYourDayData=null;


/*==============================================================================*
*GET SCIENCE RULE LIBRARY
*==============================================================================*/

function getScienceRuleLibrary(){

    if(
        !insightData ||
        !insightData.scienceSelectionRules
    ){

        return{};

    }


    const rules=
        insightData
            .scienceSelectionRules
            .rules;


    if(
        !Array.isArray(rules)
    ){

        return{};

    }


    const library={};


    rules.forEach(

        function(rule){

            if(
                rule &&
                rule.id
            ){

                library[
                    rule.id
                ]=
                    rule;

            }

        }

    );


    return library;

}


/*==============================================================================*
*GET SCIENCE OUTPUT LIBRARY
*==============================================================================*/

function getScienceOutputLibrary(){

    if(
        !insightData ||
        !insightData.scienceOutputVariants
    ){

        return{};

    }


    return(
        insightData
            .scienceOutputVariants
    );

}


/*==============================================================================*
*GET REFERENCE
*==============================================================================*/

function getReferenceById(id){

    if(
        !insightData ||
        !insightData.references ||
        !id
    ){

        return null;

    }


    return(
        insightData.references[id] ||
        null
    );

}


/*==============================================================================*
*GET SOURCE REGISTRY ITEM
*==============================================================================*/

function getSourceRegistryItem(id){

    if(
        !insightData ||
        !insightData.sourceRegistry ||
        !id
    ){

        return null;

    }


    return(
        insightData
            .sourceRegistry[id] ||
        null
    );

}


/*==============================================================================*
*CHECK REFERENCE LIFE-STAGE APPLICABILITY
*==============================================================================*/

function referenceAppliesToLifeStage(
    reference,
    lifeStage
){

    if(
        !reference ||
        !lifeStage
    ){

        return true;

    }


    if(
        !reference.appliesTo ||
        !Array.isArray(
            reference
                .appliesTo
                .lifeStage
        )
    ){

        return true;

    }


    return(
        reference
            .appliesTo
            .lifeStage
            .includes(
                lifeStage
            )
    );

}


/*==============================================================================*
*CHECK REFERENCE DIABETES-PROFILE APPLICABILITY
*==============================================================================*/

function referenceAppliesToDiabetesProfile(
    reference,
    diabetesProfile
){

    if(
        !reference ||
        !diabetesProfile
    ){

        return true;

    }


    if(
        !reference.appliesTo ||
        !Array.isArray(
            reference
                .appliesTo
                .diabetesProfile
        )
    ){

        return true;

    }


    return(
        reference
            .appliesTo
            .diabetesProfile
            .includes(
                diabetesProfile
            )
    );

}


/*==============================================================================*
*IS REFERENCE ALLOWED FOR PROFILE
*==============================================================================*/

function isReferenceAllowedForProfile(
    referenceId,
    domain
){

    const profile=
        getCurrentProfile();


    const reference=
        getReferenceById(
            referenceId
        );


    if(!reference){

        return false;

    }


    if(
        !referenceAppliesToLifeStage(
            reference,
            profile.lifeStage
        )
    ){

        return false;

    }


    if(
        !referenceAppliesToDiabetesProfile(
            reference,
            profile.diabetesProfile
        )
    ){

        return false;

    }


    if(
        !isScienceDomainAllowed(
            domain
        )
    ){

        return false;

    }


    /*==========================================================================
    PREGNANCY SAFETY
    ==========================================================================*/

    if(
        profile.lifeStage==="Pregnant"
    ){

        const exceptionIds=
            insightData &&
            insightData.lifeStageReferenceRules &&
            Array.isArray(
                insightData
                    .lifeStageReferenceRules
                    .pregnancyAdultReferenceExceptions
            )

                ? insightData
                    .lifeStageReferenceRules
                    .pregnancyAdultReferenceExceptions

                : [];


        const pregnancySpecific=
            referenceId===
                "pregnancy_glucose_individualized_care";


        const exception=
            exceptionIds.includes(
                referenceId
            );


        if(
            domain==="bloodSugar" &&
            !pregnancySpecific
        ){

            return false;

        }


        if(
            !pregnancySpecific &&
            !exception &&
            reference.domain==="movement"
        ){

            return false;

        }

    }


    /*==========================================================================
    GESTATIONAL DIABETES
    ==========================================================================*/

    if(
        profile.diabetesProfile===
            "Gestational Diabetes" &&
        domain==="bloodSugar" &&
        referenceId!==
            "pregnancy_glucose_individualized_care"
    ){

        return false;

    }


    return true;

}


/*==============================================================================*
*REFERENCE PRIORITY
*==============================================================================*/

function getReferencePriority(
    domain
){

    if(
        !insightData ||
        !insightData.referencePriority
    ){

        return 0;

    }


    return(
        Number(
            insightData
                .referencePriority[
                    domain
                ]
        ) || 0
    );

}


/*==============================================================================*
*SCIENCE CANDIDATE SCORE
*==============================================================================*/

function calculateScienceCandidateScore(
    rule,
    referenceId
){

    let score=
        calculateRuleScore(
            rule
        );


    const domain=
        normalizeDomain(
            rule.domain
        );


    score+=
        getReferencePriority(
            domain
        );


    /*==========================================================================
    PROMISE RELEVANCE
    ==========================================================================*/

    const profile=
        getCurrentProfile();


    if(
        profile.promise &&
        relevanceContext &&
        relevanceContext.domainScores
    ){

        score+=
            Number(
                relevanceContext
                    .domainScores[
                        domain
                    ]
            ) || 0;

    }


    /*==========================================================================
    PROFILE-SPECIFIC REFERENCE BOOST
    ==========================================================================*/

    if(
        referenceId===
            "pregnancy_glucose_individualized_care"
    ){

        score+=150;

    }


    if(
        referenceId===
            "ada_individualized_glucose_goals" &&
        domain==="bloodSugar"
    ){

        score+=40;

    }


    return score;

}


/*==============================================================================*
*BUILD SCIENCE CANDIDATES
*==============================================================================*/

function buildScienceCandidates(){

    if(!relevanceContext){

        buildRelevanceContext();

    }


    const state=
        getCurrentPatterns();


    const profile=
        getCurrentProfile();


    const selectionLibrary=
        getScienceRuleLibrary();


    const outputLibrary=
        getScienceOutputLibrary();


    const candidates=[];


    Object.keys(
        outputLibrary
    ).forEach(

        function(key){

            const outputRule=
                outputLibrary[key];


            if(
                !outputRule ||
                outputRule.active===false
            ){

                return;

            }


            if(
                !ruleRequirementsMet(
                    outputRule,
                    state,
                    profile
                )
            ){

                return;

            }


            const domain=
                normalizeDomain(
                    outputRule.domain
                );


            if(
                !isScienceDomainAllowed(
                    domain
                )
            ){

                return;

            }


            const sourceIds=
                Array.isArray(
                    outputRule.sourceIds
                )
                    ? outputRule.sourceIds
                    : [];


            if(!sourceIds.length){

                return;

            }


            const allowedSources=
                sourceIds.filter(

                    function(referenceId){

                        return isReferenceAllowedForProfile(

                            referenceId,

                            domain

                        );

                    }

                );


            if(!allowedSources.length){

                return;

            }


            const matchingSelectionRule=
                Object.values(
                    selectionLibrary
                ).find(

                    function(rule){

                        return(
                            rule &&
                            normalizeDomain(
                                rule.domain
                            )===domain &&
                            ruleRequirementsMet(
                                rule,
                                state,
                                profile
                            )
                        );

                    }

                );


            const baseRule=
                matchingSelectionRule ||
                outputRule;


            const primaryReference=
                allowedSources[0];


            const score=
                calculateScienceCandidateScore(

                    baseRule,

                    primaryReference

                ) +
                (
                    Number(
                        outputRule.priority
                    ) || 0
                );


            candidates.push({

                id:
                    key,

                domain:
                    domain,

                outputRule:
                    outputRule,

                selectionRule:
                    matchingSelectionRule ||
                    null,

                sourceIds:
                    allowedSources,

                primarySourceId:
                    primaryReference,

                score:
                    score

            });

        }

    );


    return candidates.sort(

        function(a,b){

            return(
                b.score-
                a.score
            );

        }

    );

}


/*==============================================================================*
*REMOVE DUPLICATE SCIENCE MEANING
*
*Avoid:
*
*two sleep paragraphs
*two movement paragraphs
*two near-identical references
*==============================================================================*/

function deduplicateScienceCandidates(
    candidates
){

    const selected=[];

    const usedDomains=
        new Set();

    const usedSources=
        new Set();


    candidates.forEach(

        function(candidate){

            if(
                usedDomains.has(
                    candidate.domain
                )
            ){

                return;

            }


            const duplicateSource=
                candidate
                    .sourceIds
                    .some(

                        function(id){

                            return(
                                usedSources.has(id)
                            );

                        }

                    );


            if(
                duplicateSource &&
                selected.length>0
            ){

                return;

            }


            selected.push(
                candidate
            );


            usedDomains.add(
                candidate.domain
            );


            candidate
                .sourceIds
                .forEach(

                    function(id){

                        usedSources.add(id);

                    }

                );

        }

    );


    return selected;

}


/*==============================================================================*
*SCIENCE ITEM TEXT
*==============================================================================*/

function buildScienceText(
    candidate
){

    if(
        !candidate ||
        !candidate.outputRule
    ){

        return"";

    }


    const variants=
        candidate
            .outputRule
            .variants;


    if(
        !Array.isArray(variants) ||
        !variants.length
    ){

        return"";

    }


    return chooseStableVariant(

        variants,

        "science_" +
        candidate.id

    );

}


/*==============================================================================*
*BUILD SOURCE DISPLAY
*==============================================================================*/

function buildSourceDisplay(
    sourceId
){

    const source=
        getSourceRegistryItem(
            sourceId
        );


    if(!source){

        return null;

    }


    return{

        id:
            sourceId,

        authority:
            safeString(
                source.displayAuthority ||
                source.authority
            ),

        title:
            safeString(
                source.title
            ),

        year:
            (
                typeof source.year!=="undefined"
                &&
                source.year!==null
            )
                ? source.year
                : null,

        domain:
            safeString(
                source.domain
            )

    };

}


/*==============================================================================*
*BUILD ONE SCIENCE ITEM
*==============================================================================*/

function buildScienceItem(
    candidate
){

    const text=
        buildScienceText(
            candidate
        );


    if(!text){

        return null;

    }


    const sources=
        candidate
            .sourceIds

            .map(

                function(sourceId){

                    return buildSourceDisplay(
                        sourceId
                    );

                }

            )

            .filter(Boolean);


    return{

        id:
            candidate.id,

        domain:
            candidate.domain,

        authority:
            sources.length
                ? sources[0].authority
                : "",

        text:
            text,

        sourceIds:
            candidate.sourceIds.slice(),

        sources:
            sources,

        score:
            candidate.score

    };

}


/*==============================================================================*
*SCIENCE MAXIMUM
*==============================================================================*/

function getScienceMaximum(){

    if(
        insightData &&
        insightData
            .scienceSelectionRules &&
        Number.isFinite(
            Number(
                insightData
                    .scienceSelectionRules
                    .maximumReferences
            )
        )
    ){

        return Number(
            insightData
                .scienceSelectionRules
                .maximumReferences
        );

    }


    return 2;

}


/*==============================================================================*
*SPECIAL PREGNANCY SCIENCE PRIORITY
*
*If pregnancy-related glucose context exists,
*it should replace generic glucose context.
*==============================================================================*/

function applyPregnancyScienceOverride(
    candidates
){

    const profile=
        getCurrentProfile();


    if(
        profile.lifeStage!=="Pregnant" &&
        profile.diabetesProfile!==
            "Gestational Diabetes"
    ){

        return candidates;

    }


    const pregnancyCandidate=
        candidates.find(

            function(candidate){

                return(
                    candidate.id===
                        "pregnancyGlucoseContext" ||
                    candidate
                        .sourceIds
                        .includes(
                            "pregnancy_glucose_individualized_care"
                        )
                );

            }

        );


    if(!pregnancyCandidate){

        return candidates;

    }


    return [

        pregnancyCandidate,

        ...candidates.filter(

            function(candidate){

                if(
                    candidate===
                        pregnancyCandidate
                ){

                    return false;

                }


                if(
                    candidate.domain===
                        "bloodSugar"
                ){

                    return false;

                }


                return true;

            }

        )

    ];

}


/*==============================================================================*
*BUILD SCIENCE & YOUR DAY
*==============================================================================*/

function buildScienceAndYourDay(){

    if(!derivedPatterns){

        derivePatterns();

    }


    if(!relevanceContext){

        buildRelevanceContext();

    }


    const dataLevel=
        derivedPatterns &&
        derivedPatterns.dataCoverage
            ? derivedPatterns
                .dataCoverage
                .dataLevel
            : "NONE";


    /*==========================================================================
    NO DATA
    ==========================================================================*/

    if(dataLevel==="NONE"){

        scienceAndYourDayData=[];

        return[];

    }


    let candidates=
        buildScienceCandidates();


    candidates=
        applyPregnancyScienceOverride(
            candidates
        );


    candidates=
        deduplicateScienceCandidates(
            candidates
        );


    const maximum=
        getScienceMaximum();


    /*==========================================================================
    VERY LIGHT DATA
    Use at most ONE directly relevant science item.
    ==========================================================================*/

    const finalMaximum=

        dataLevel==="VERY_LIGHT"
            ? 1
            : maximum;


    const selected=
        candidates
            .slice(
                0,
                finalMaximum
            )
            .map(

                function(candidate){

                    return buildScienceItem(
                        candidate
                    );

                }

            )
            .filter(Boolean);


    scienceAndYourDayData=
        selected;


    return clone(
        scienceAndYourDayData
    );

}


/*==============================================================================*
*GET USED SCIENCE SOURCE IDS
*==============================================================================*/

function getScienceSourceIds(){

    if(!scienceAndYourDayData){

        buildScienceAndYourDay();

    }


    const ids=[];


    scienceAndYourDayData.forEach(

        function(item){

            if(
                !item ||
                !Array.isArray(
                    item.sourceIds
                )
            ){

                return;

            }


            item.sourceIds.forEach(

                function(id){

                    if(
                        !ids.includes(id)
                    ){

                        ids.push(id);

                    }

                }

            );

        }

    );


    return ids;

}


/*==============================================================================*
*PUBLIC ENGINE API — SECTION E
*==============================================================================*/

window.TrestleW007Engine.getScienceAndYourDay=
    function(){

        if(!todayW005){

            readEngineInputs();

        }


        return clone(
            buildScienceAndYourDay()
        );

    };


window.TrestleW007Engine.getScienceSourceIds=
    function(){

        return clone(
            getScienceSourceIds()
        );

    };


/*==============================================================================*
*SECTION E END
*
*SECTION F CONTINUES DIRECTLY BELOW.
*
*DO NOT ADD })(); YET.
*==============================================================================*/
/*==============================================================================*
*SECTION F
*PROMISE REFLECTION
*+
*ONE THING TO CARRY INTO TOMORROW
*
*Purpose:
*
*1. Select ONE Promise-linked reflection.
*2. Select ONE Tomorrow Focus.
*3. Prefer actual recorded evidence.
*4. Prefer maintaining success when appropriate.
*5. Never invent a problem merely to fill the report.
*==============================================================================*/


/*==============================================================================*
*RUNTIME
*==============================================================================*/

let promiseReflectionData=null;

let tomorrowFocusData=null;


/*==============================================================================*
*GET PROMISE REFLECTION LIBRARY
*==============================================================================*/

function getPromiseReflectionLibrary(){

    if(
        !insightData ||
        !insightData.promiseReflectionLibrary
    ){

        return{};

    }


    return(
        insightData.promiseReflectionLibrary
    );

}


/*==============================================================================*
*GET TOMORROW FOCUS LIBRARY
*==============================================================================*/

function getTomorrowFocusLibrary(){

    if(
        !insightData ||
        !insightData.tomorrowFocusLibrary
    ){

        return{};

    }


    return(
        insightData.tomorrowFocusLibrary
    );

}


/*==============================================================================*
*GET PROMISE DATA RULE
*==============================================================================*/

function getPromiseDataRule(){

    const profile=
        getCurrentProfile();


    if(
        !profile ||
        !profile.promise
    ){

        return null;

    }


    return getPromiseRule(
        profile.promise
    );

}


/*==============================================================================*
*IS STRONG POSITIVE PATTERN
*
*Used to avoid constantly searching for something to "fix".
*==============================================================================*/

function isStrongPositivePattern(
    state
){

    const positivePatterns=[

        "multiple_movement_sessions",

        "movement_recorded",

        "adult_sleep_reference_met",

        "sleep_quality_good",

        "stress_low",

        "mood_good",

        "meal_sequence_available"

    ];


    return positivePatterns.some(

        function(id){

            return hasPattern(
                state,
                id
            );

        }

    );

}


/*==============================================================================*
*IS STRONG ATTENTION PATTERN
*==============================================================================*/

function isStrongAttentionPattern(
    state
){

    const attentionPatterns=[

        "clearly_shorter_sleep",

        "shorter_sleep",

        "sleep_quality_poor",

        "stress_high",

        "medication_missed",

        "long_recorded_meal_interval",

        "mood_low"

    ];


    return attentionPatterns.some(

        function(id){

            return hasPattern(
                state,
                id
            );

        }

    );

}


/*==============================================================================*
*PROMISE REFLECTION CANDIDATES
*==============================================================================*/

function buildPromiseReflectionCandidates(){

    const profile=
        getCurrentProfile();


    const state=
        getCurrentPatterns();


    if(
        !profile.promise
    ){

        return[];

    }


    const library=
        getPromiseReflectionLibrary();


    return Object.keys(
        library
    )

        .map(

            function(key){

                return{

                    key:
                        key,

                    rule:
                        library[key]

                };

            }

        )

        .filter(

            function(item){

                const rule=
                    item.rule;


                if(
                    !rule ||
                    rule.active===false
                ){

                    return false;

                }


                if(
                    rule.promise!==
                        profile.promise
                ){

                    return false;

                }


                return ruleRequirementsMet(
                    rule,
                    state,
                    profile
                );

            }

        )

        .map(

            function(item){

                return{

                    key:
                        item.key,

                    rule:
                        item.rule,

                    score:
                        calculateRuleScore(
                            item.rule
                        )

                };

            }

        )

        .sort(

            function(a,b){

                return(
                    b.score-
                    a.score
                );

            }

        );

}


/*==============================================================================*
*GET SPARSE PROMISE REFLECTION
*==============================================================================*/

function getSparsePromiseReflection(){

    const profile=
        getCurrentProfile();


    const promiseRule=
        getPromiseDataRule();


    if(
        !profile.promise
    ){

        return null;

    }


    let text="";


    if(
        promiseRule &&
        promiseRule.sparseDataVariant
    ){

        text=
            safeString(
                promiseRule.sparseDataVariant
            );

    }


    if(!text){

        text=

            "Your " +
            profile.promise +
            " Promise remains your direction, but today's recorded information is too limited for TRESTLE to identify a specific pattern without guessing.";

    }


    return{

        promise:
            profile.promise,

        domain:
            "general",

        ruleId:
            "promise_sparse_fallback",

        text:
            text,

        sparse:
            true

    };

}


/*==============================================================================*
*BUILD PROMISE REFLECTION
*==============================================================================*/

function buildPromiseReflection(){

    if(!derivedPatterns){

        derivePatterns();

    }


    if(!relevanceContext){

        buildRelevanceContext();

    }


    const profile=
        getCurrentProfile();


    const state=
        getCurrentPatterns();


    const dataLevel=
        state &&
        state.dataCoverage
            ? state
                .dataCoverage
                .dataLevel
            : "NONE";


    /*==========================================================================
    NO PROMISE
    ==========================================================================*/

    if(
        !profile.promise
    ){

        promiseReflectionData=
            null;

        return null;

    }


    /*==========================================================================
    NO DATA
    ==========================================================================*/

    if(
        dataLevel==="NONE"
    ){

        promiseReflectionData=
            null;

        return null;

    }


    const candidates=
        buildPromiseReflectionCandidates();


    if(
        candidates.length
    ){

        const selected=
            candidates[0];


        const variants=
            selected.rule.variants;


        const text=
            chooseStableVariant(

                variants,

                "promise_reflection_" +
                selected.key

            );


        promiseReflectionData={

            promise:
                profile.promise,

            domain:
                normalizeDomain(
                    selected.rule.domain
                ),

            ruleId:
                selected.key,

            text:
                text,

            score:
                selected.score,

            sparse:
                false

        };


        return clone(
            promiseReflectionData
        );

    }


    /*==========================================================================
    LIMITED DATA
    ==========================================================================*/

    if(
        dataLevel==="VERY_LIGHT" ||
        dataLevel==="LIGHT"
    ){

        promiseReflectionData=
            getSparsePromiseReflection();


        return clone(
            promiseReflectionData
        );

    }


    /*==========================================================================
    FULL DATA BUT NO MATCHING RULE
    Use Promise rule's general reflection.
    ==========================================================================*/

    const promiseRule=
        getPromiseDataRule();


    if(
        promiseRule &&
        Array.isArray(
            promiseRule.reflectionVariants
        ) &&
        promiseRule.reflectionVariants.length
    ){

        promiseReflectionData={

            promise:
                profile.promise,

            domain:
                "general",

            ruleId:
                "promise_general_reflection",

            text:
                chooseStableVariant(

                    promiseRule
                        .reflectionVariants,

                    "promise_general_" +
                    profile.promise

                ),

            score:
                0,

            sparse:
                false

        };


        return clone(
            promiseReflectionData
        );

    }


    promiseReflectionData=
        getSparsePromiseReflection();


    return clone(
        promiseReflectionData
    );

}


/*==============================================================================*
*GET FOCUS CANDIDATES
*==============================================================================*/

function buildTomorrowFocusCandidates(){

    const profile=
        getCurrentProfile();


    const state=
        getCurrentPatterns();


    const library=
        getTomorrowFocusLibrary();


    return Object.keys(
        library
    )

        .map(

            function(key){

                return{

                    key:
                        key,

                    rule:
                        library[key]

                };

            }

        )

        .filter(

            function(item){

                const rule=
                    item.rule;


                if(
                    !rule ||
                    rule.active===false
                ){

                    return false;

                }


                return ruleRequirementsMet(
                    rule,
                    state,
                    profile
                );

            }

        )

        .map(

            function(item){

                let score=
                    calculateRuleScore(
                        item.rule
                    );


                /*==============================================================
                MAINTAIN-SUCCESS BOOST
                ==============================================================*/

                const ruleId=
                    safeString(
                        item.rule.id ||
                        item.key
                    );


                const looksLikeMaintain=
                    (
                        ruleId.includes(
                            "success"
                        ) ||
                        ruleId.includes(
                            "maintain"
                        ) ||
                        ruleId.includes(
                            "repeat"
                        )
                    );


                if(
                    looksLikeMaintain &&
                    isStrongPositivePattern(
                        state
                    )
                ){

                    score+=35;

                }


                /*==============================================================
                ATTENTION BOOST
                ==============================================================*/

                if(
                    !looksLikeMaintain &&
                    isStrongAttentionPattern(
                        state
                    )
                ){

                    score+=20;

                }


                return{

                    key:
                        item.key,

                    rule:
                        item.rule,

                    score:
                        score

                };

            }

        )

        .sort(

            function(a,b){

                return(
                    b.score-
                    a.score
                );

            }

        );

}


/*==============================================================================*
*IS MEDICAL / UNSAFE FOCUS
*
*Additional hard guard before final selection.
*==============================================================================*/

function isUnsafeFocusText(
    text
){

    const value=
        safeString(
            text
        ).toLowerCase();


    if(!value){

        return true;

    }


    const unsafePhrases=[

        "change your insulin",

        "take more insulin",

        "take less insulin",

        "change your medication",

        "stop your medication",

        "increase your medication",

        "reduce your medication",

        "double your dose",

        "skip your dose",

        "take a missed dose",

        "your glucose target",

        "you must exercise",

        "you must drink",

        "you need exactly",

        "you should eat exactly"

    ];


    return unsafePhrases.some(

        function(phrase){

            return value.includes(
                phrase
            );

        }

    );

}


/*==============================================================================*
*PROMISE DOMAIN MATCH
*==============================================================================*/

function focusMatchesPromise(
    rule
){

    const profile=
        getCurrentProfile();


    if(
        !profile.promise ||
        !rule
    ){

        return false;

    }


    if(
        Array.isArray(
            rule.promises
        )
    ){

        return rule.promises.includes(
            profile.promise
        );

    }


    return(
        rule.promise===
        profile.promise
    );

}


/*==============================================================================*
*SELECT TOMORROW FOCUS
*==============================================================================*/

function buildTomorrowFocus(){

    if(!derivedPatterns){

        derivePatterns();

    }


    if(!relevanceContext){

        buildRelevanceContext();

    }


    const state=
        getCurrentPatterns();


    const dataLevel=
        state &&
        state.dataCoverage
            ? state
                .dataCoverage
                .dataLevel
            : "NONE";


    /*==========================================================================
    NO DATA
    ==========================================================================*/

    if(
        dataLevel==="NONE"
    ){

        tomorrowFocusData=
            null;

        return null;

    }


    let candidates=
        buildTomorrowFocusCandidates();


    /*==========================================================================
    PREFER PROMISE MATCH
    ==========================================================================*/

    const promiseCandidates=
        candidates.filter(

            function(item){

                return focusMatchesPromise(
                    item.rule
                );

            }

        );


    if(
        promiseCandidates.length
    ){

        candidates=
            promiseCandidates;

    }


    /*==========================================================================
    STRONG POSITIVE DAY
    If equally relevant, prefer maintaining success.
    ==========================================================================*/

    if(
        isStrongPositivePattern(
            state
        )
    ){

        const maintainCandidates=
            candidates.filter(

                function(item){

                    const id=
                        safeString(
                            item.rule.id ||
                            item.key
                        );


                    return(
                        id.includes(
                            "success"
                        ) ||
                        id.includes(
                            "maintain"
                        ) ||
                        id.includes(
                            "repeat"
                        )
                    );

                }

            );


        if(
            maintainCandidates.length &&
            !isStrongAttentionPattern(
                state
            )
        ){

            candidates=
                maintainCandidates;

        }

    }


    /*==========================================================================
    SELECT FIRST SAFE CANDIDATE
    ==========================================================================*/

    for(
        let i=0;
        i<candidates.length;
        i++
    ){

        const candidate=
            candidates[i];


        const variants=
            candidate.rule.variants;


        const text=
            chooseStableVariant(

                variants,

                "tomorrow_focus_" +
                candidate.key

            );


        if(
            !text ||
            isUnsafeFocusText(
                text
            )
        ){

            continue;

        }


        tomorrowFocusData={

            id:
                candidate.key,

            domain:
                normalizeDomain(
                    candidate.rule.domain
                ),

            text:
                text,

            score:
                candidate.score,

            promiseMatched:
                focusMatchesPromise(
                    candidate.rule
                )

        };


        return clone(
            tomorrowFocusData
        );

    }


    /*==========================================================================
    FALLBACK
    ==========================================================================*/

    const fallbackRule=
        getTomorrowFocusLibrary()
            .promise_sparse_fallback;


    if(
        fallbackRule &&
        Array.isArray(
            fallbackRule.variants
        ) &&
        fallbackRule.variants.length
    ){

        const text=
            chooseStableVariant(

                fallbackRule.variants,

                "tomorrow_focus_fallback"

            );


        if(
            text &&
            !isUnsafeFocusText(
                text
            )
        ){

            tomorrowFocusData={

                id:
                    "promise_sparse_fallback",

                domain:
                    "general",

                text:
                    text,

                score:
                    0,

                promiseMatched:
                    true

            };


            return clone(
                tomorrowFocusData
            );

        }

    }


    tomorrowFocusData=
        null;


    return null;

}


/*==============================================================================*
*GET PROMISE ALIGNMENT SUMMARY
*
*Convenience object used by the final composer.
*==============================================================================*/

function buildPromiseAlignmentSummary(){

    const reflection=
        buildPromiseReflection();


    const focus=
        buildTomorrowFocus();


    return{

        reflection:
            reflection,

        tomorrowFocus:
            focus

    };

}


/*==============================================================================*
*PUBLIC ENGINE API — SECTION F
*==============================================================================*/

window.TrestleW007Engine.getPromiseReflection=
    function(){

        if(!todayW005){

            readEngineInputs();

        }


        return clone(
            buildPromiseReflection()
        );

    };


window.TrestleW007Engine.getTomorrowFocus=
    function(){

        if(!todayW005){

            readEngineInputs();

        }


        return clone(
            buildTomorrowFocus()
        );

    };


window.TrestleW007Engine.getPromiseAlignment=
    function(){

        if(!todayW005){

            readEngineInputs();

        }


        return clone(
            buildPromiseAlignmentSummary()
        );

    };


/*==============================================================================*
*SECTION F END
*
*SECTION G CONTINUES DIRECTLY BELOW.
*
*DO NOT ADD })(); YET.
*==============================================================================*/
/*==============================================================================*
*SECTION G
*DOCTOR QUESTIONS
*CONTRADICTION HANDLING
*FINAL SAFETY VALIDATION
*==============================================================================*/


/*==============================================================================*
*RUNTIME
*==============================================================================*/

let doctorQuestionsData=null;

let contradictionData=null;


/*==============================================================================*
*GET DOCTOR QUESTION LIBRARY
*==============================================================================*/

function getDoctorQuestionLibrary(){

    if(
        !insightData ||
        !insightData.doctorQuestionLibrary
    ){

        return{};

    }


    return(
        insightData.doctorQuestionLibrary
    );

}


/*==============================================================================*
*GET CONTRADICTION LIBRARY
*==============================================================================*/

function getContradictionLibrary(){

    if(
        !insightData ||
        !insightData.contradictionRules
    ){

        return{};

    }


    return(
        insightData.contradictionRules
    );

}


/*==============================================================================*
*GET LIFE-STAGE DOCTOR MODIFIER
*==============================================================================*/

function getLifeStageDoctorModifier(){

    const profile=
        getCurrentProfile();


    if(
        !insightData ||
        !insightData
            .lifeStageDoctorQuestionModifiers ||
        !profile.lifeStage
    ){

        return{

            multiplier:1,

            boostedDomains:[]

        };

    }


    const modifier=
        insightData
            .lifeStageDoctorQuestionModifiers[
                profile.lifeStage
            ];


    if(!modifier){

        return{

            multiplier:1,

            boostedDomains:[]

        };

    }


    return{

        multiplier:
            Number(
                modifier.multiplier
            ) || 1,

        boostedDomains:
            Array.isArray(
                modifier.boostedDomains
            )
                ? modifier.boostedDomains
                : []

    };

}


/*==============================================================================*
*GET DIABETES-PROFILE DOCTOR MODIFIER
*==============================================================================*/

function getDiabetesDoctorModifier(){

    const profile=
        getCurrentProfile();


    if(
        !insightData ||
        !insightData
            .diabetesProfileDoctorQuestionModifiers ||
        !profile.diabetesProfile
    ){

        return{

            multiplier:1,

            boostedDomains:[]

        };

    }


    const modifier=
        insightData
            .diabetesProfileDoctorQuestionModifiers[
                profile.diabetesProfile
            ];


    if(!modifier){

        return{

            multiplier:1,

            boostedDomains:[]

        };

    }


    return{

        multiplier:
            Number(
                modifier.multiplier
            ) || 1,

        boostedDomains:
            Array.isArray(
                modifier.boostedDomains
            )
                ? modifier.boostedDomains
                : []

    };

}


/*==============================================================================*
*CALCULATE DOCTOR QUESTION SCORE
*==============================================================================*/

function calculateDoctorQuestionScore(
    rule
){

    let score=
        calculateRuleScore(
            rule
        );


    const domain=
        normalizeDomain(
            rule.domain
        );


    const lifeStageModifier=
        getLifeStageDoctorModifier();


    const diabetesModifier=
        getDiabetesDoctorModifier();


    score*=
        lifeStageModifier.multiplier;


    score*=
        diabetesModifier.multiplier;


    if(
        lifeStageModifier
            .boostedDomains
            .includes(domain)
    ){

        score+=35;

    }


    if(
        diabetesModifier
            .boostedDomains
            .includes(domain)
    ){

        score+=40;

    }


    /*==========================================================================
    STRONG MEDICATION SAFETY BOOST
    ==========================================================================*/

    if(
        rule.id===
            "doctor_medication_missed" &&
        hasPattern(
            getCurrentPatterns(),
            "medication_missed"
        )
    ){

        score+=75;

    }


    /*==========================================================================
    PREGNANCY PROFILE-SPECIFIC BOOST
    ==========================================================================*/

    if(
        rule.id===
            "pregnancy_glucose_targets"
    ){

        score+=100;

    }


    return score;

}


/*==============================================================================*
*BUILD DOCTOR QUESTION CANDIDATES
*==============================================================================*/

function buildDoctorQuestionCandidates(){

    const library=
        getDoctorQuestionLibrary();


    const state=
        getCurrentPatterns();


    const profile=
        getCurrentProfile();


    const candidates=[];


    Object.keys(
        library
    ).forEach(

        function(key){

            const rule=
                library[key];


            if(
                !rule ||
                rule.active===false
            ){

                return;

            }


            if(
                !ruleRequirementsMet(
                    rule,
                    state,
                    profile
                )
            ){

                return;

            }


            candidates.push({

                key:
                    key,

                rule:
                    rule,

                score:
                    calculateDoctorQuestionScore(
                        rule
                    )

            });

        }

    );


    return candidates.sort(

        function(a,b){

            return(
                b.score-
                a.score
            );

        }

    );

}


/*==============================================================================*
*NORMALIZE QUESTION MEANING
*
*Used to avoid near-duplicate questions.
*==============================================================================*/

function normalizeQuestionMeaning(
    question
){

    return safeString(
        question
    )
        .toLowerCase()
        .replace(
            /[^a-z0-9\s]/g,
            ""
        )
        .replace(
            /\s+/g,
            " "
        )
        .trim();

}


/*==============================================================================*
*QUESTION SIMILARITY
*
*Simple word-overlap safeguard.
*==============================================================================*/

function questionsAreSimilar(
    questionA,
    questionB
){

    const a=
        normalizeQuestionMeaning(
            questionA
        );


    const b=
        normalizeQuestionMeaning(
            questionB
        );


    if(
        !a ||
        !b
    ){

        return false;

    }


    if(a===b){

        return true;

    }


    const wordsA=
        new Set(
            a.split(" ")
                .filter(
                    function(word){

                        return word.length>3;

                    }
                )
        );


    const wordsB=
        new Set(
            b.split(" ")
                .filter(
                    function(word){

                        return word.length>3;

                    }
                )
        );


    if(
        !wordsA.size ||
        !wordsB.size
    ){

        return false;

    }


    let overlap=0;


    wordsA.forEach(

        function(word){

            if(
                wordsB.has(word)
            ){

                overlap++;

            }

        }

    );


    const smaller=
        Math.min(
            wordsA.size,
            wordsB.size
        );


    return(
        smaller>0 &&
        overlap/smaller>=0.65
    );

}


/*==============================================================================*
*GET MINIMUM DOCTOR QUESTION PRIORITY
*==============================================================================*/

function getDoctorQuestionMinimumPriority(){

    if(
        insightData &&
        insightData
            .doctorQuestionSelectionRules &&
        Number.isFinite(
            Number(
                insightData
                    .doctorQuestionSelectionRules
                    .minimumPriorityForDisplay
            )
        )
    ){

        return Number(
            insightData
                .doctorQuestionSelectionRules
                .minimumPriorityForDisplay
        );

    }


    return 65;

}


/*==============================================================================*
*GET MAXIMUM DOCTOR QUESTIONS
*==============================================================================*/

function getMaximumDoctorQuestions(){

    if(
        insightData &&
        insightData
            .doctorQuestionSelectionRules &&
        Number.isFinite(
            Number(
                insightData
                    .doctorQuestionSelectionRules
                    .maximumQuestions
            )
        )
    ){

        return Number(
            insightData
                .doctorQuestionSelectionRules
                .maximumQuestions
        );

    }


    return 3;

}


/*==============================================================================*
*SELECT QUESTIONS FROM RULE
*
*We do not automatically take all 3 questions from one rule.
*
*This allows the final section to cover more than one meaningful area.
*==============================================================================*/

function chooseQuestionFromRule(
    rule,
    key
){

    if(
        !rule ||
        !Array.isArray(
            rule.questions
        ) ||
        !rule.questions.length
    ){

        return"";

    }


    return chooseStableVariant(

        rule.questions,

        "doctor_question_" +
        key

    );

}


/*==============================================================================*
*BUILD DOCTOR QUESTIONS
*==============================================================================*/

function buildDoctorQuestions(){

    if(!derivedPatterns){

        derivePatterns();

    }


    if(!relevanceContext){

        buildRelevanceContext();

    }


    const state=
        getCurrentPatterns();


    const dataLevel=
        state &&
        state.dataCoverage
            ? state
                .dataCoverage
                .dataLevel
            : "NONE";


    /*==========================================================================
    NO DATA
    ==========================================================================*/

    if(dataLevel==="NONE"){

        doctorQuestionsData=[];

        return[];

    }


    const candidates=
        buildDoctorQuestionCandidates();


    const minimumPriority=
        getDoctorQuestionMinimumPriority();


    const maximum=
        getMaximumDoctorQuestions();


    const selected=[];


    for(
        let i=0;
        i<candidates.length;
        i++
    ){

        if(
            selected.length>=maximum
        ){

            break;

        }


        const candidate=
            candidates[i];


        if(
            candidate.score<
            minimumPriority
        ){

            continue;

        }


        const question=
            chooseQuestionFromRule(

                candidate.rule,

                candidate.key

            );


        if(!question){

            continue;

        }


        const duplicate=
            selected.some(

                function(item){

                    return questionsAreSimilar(

                        item.question,

                        question

                    );

                }

            );


        if(duplicate){

            continue;

        }


        selected.push({

            id:
                candidate.key,

            domain:
                normalizeDomain(
                    candidate.rule.domain
                ),

            question:
                question,

            score:
                candidate.score

        });

    }


    /*==========================================================================
    VERY LIGHT DATA
    Maximum ONE supported question.
    ==========================================================================*/

    doctorQuestionsData=

        dataLevel==="VERY_LIGHT"

            ? selected.slice(
                0,
                1
            )

            : selected;


    return clone(
        doctorQuestionsData
    );

}


/*==============================================================================*
*DOCTOR SECTION INTRO
*==============================================================================*/

function getDoctorSectionIntro(){

    if(
        !doctorQuestionsData
    ){

        buildDoctorQuestions();

    }


    if(
        !doctorQuestionsData.length
    ){

        return"";

    }


    const variants=
        insightData &&
        Array.isArray(
            insightData
                .doctorSectionIntroVariants
        )
            ? insightData
                .doctorSectionIntroVariants
            : [];


    if(!variants.length){

        return(
            "If you're meeting your doctor soon, these may be useful questions to take with you."
        );

    }


    return chooseStableVariant(

        variants,

        "doctor_section_intro"

    );

}


/*==============================================================================*
*BUILD CONTRADICTION CANDIDATES
*==============================================================================*/

function buildContradictionCandidates(){

    const library=
        getContradictionLibrary();


    const state=
        getCurrentPatterns();


    const profile=
        getCurrentProfile();


    const candidates=[];


    Object.keys(
        library
    ).forEach(

        function(key){

            const rule=
                library[key];


            if(
                !rule ||
                rule.active===false
            ){

                return;

            }


            if(
                !ruleRequirementsMet(
                    rule,
                    state,
                    profile
                )
            ){

                return;

            }


            candidates.push({

                key:
                    key,

                rule:
                    rule,

                score:
                    calculateRuleScore(
                        rule
                    )

            });

        }

    );


    return candidates.sort(

        function(a,b){

            return(
                b.score-
                a.score
            );

        }

    );

}


/*==============================================================================*
*BUILD CONTRADICTION OBSERVATION
*==============================================================================*/

function buildContradictionObservation(){

    if(!derivedPatterns){

        derivePatterns();

    }


    const candidates=
        buildContradictionCandidates();


    if(!candidates.length){

        contradictionData=
            null;

        return null;

    }


    const selected=
        candidates[0];


    const text=
        chooseStableVariant(

            selected.rule.variants,

            "contradiction_" +
            selected.key

        );


    if(!text){

        contradictionData=
            null;

        return null;

    }


    contradictionData={

        id:
            selected.key,

        text:
            text,

        score:
            selected.score

    };


    return clone(
        contradictionData
    );

}


/*==============================================================================*
*TEXT SAFETY BLACKLIST
*==============================================================================*/

function containsSafetyBlacklist(
    text
){

    const value=
        safeString(
            text
        ).toLowerCase();


    if(!value){

        return false;

    }


    const blacklist=
        insightData &&
        Array.isArray(
            insightData
                .finalSafetyBlacklist
        )
            ? insightData
                .finalSafetyBlacklist
            : [];


    return blacklist.some(

        function(item){

            return value.includes(

                safeString(
                    item
                ).toLowerCase()

            );

        }

    );

}


/*==============================================================================*
*ADDITIONAL TREATMENT / DIAGNOSIS GUARD
*==============================================================================*/

function containsUnsafeMedicalInstruction(
    text
){

    const value=
        safeString(
            text
        ).toLowerCase();


    if(!value){

        return false;

    }


    const unsafePatterns=[

        /\byou have diabetes\b/,

        /\byou have depression\b/,

        /\byou have anxiety\b/,

        /\byou have a sleep disorder\b/,

        /\bincrease .*insulin\b/,

        /\breduce .*insulin\b/,

        /\bchange .*insulin\b/,

        /\bincrease .*medication\b/,

        /\breduce .*medication\b/,

        /\bstop .*medication\b/,

        /\bdouble .*dose\b/,

        /\bskip .*dose\b/,

        /\btake .*missed dose\b/

    ];


    return unsafePatterns.some(

        function(pattern){

            return pattern.test(
                value
            );

        }

    );

}


/*==============================================================================*
*VALIDATE ONE TEXT
*==============================================================================*/

function isSafeInsightText(
    text
){

    const value=
        safeString(
            text
        );


    if(!value){

        return false;

    }


    if(
        containsSafetyBlacklist(
            value
        )
    ){

        return false;

    }


    if(
        containsUnsafeMedicalInstruction(
            value
        )
    ){

        return false;

    }


    return true;

}


/*==============================================================================*
*SANITIZE TEXT OR NULL
*==============================================================================*/

function safeInsightTextOrNull(
    text
){

    return isSafeInsightText(
        text
    )
        ? safeString(
            text
        )
        : null;

}


/*==============================================================================*
*SANITIZE SCIENCE ITEMS
*==============================================================================*/

function sanitizeScienceItems(
    items
){

    if(
        !Array.isArray(items)
    ){

        return[];

    }


    return items.filter(

        function(item){

            return(
                item &&
                isSafeInsightText(
                    item.text
                )
            );

        }

    );

}


/*==============================================================================*
*SANITIZE DOCTOR QUESTIONS
*
*Doctor questions may ask about medication safely,
*but may not themselves instruct treatment.
*==============================================================================*/

function sanitizeDoctorQuestions(
    items
){

    if(
        !Array.isArray(items)
    ){

        return[];

    }


    return items.filter(

        function(item){

            if(
                !item ||
                !item.question
            ){

                return false;

            }


            const question=
                safeString(
                    item.question
                );


            /*
            Questions such as:
            "If I miss a dose, what would you like me to do?"
            are intentionally allowed.

            We therefore apply only direct instruction checks,
            not the full wording blacklist.
            */

            if(
                containsUnsafeMedicalInstruction(
                    question
                )
            ){

                return false;

            }


            return true;

        }

    );

}


/*==============================================================================*
*VALIDATE PROMISE REFLECTION
*==============================================================================*/

function sanitizePromiseReflection(
    reflection
){

    if(
        !reflection ||
        !reflection.text
    ){

        return null;

    }


    if(
        !isSafeInsightText(
            reflection.text
        )
    ){

        return null;

    }


    return clone(
        reflection
    );

}


/*==============================================================================*
*VALIDATE TOMORROW FOCUS
*==============================================================================*/

function sanitizeTomorrowFocus(
    focus
){

    if(
        !focus ||
        !focus.text
    ){

        return null;

    }


    if(
        isUnsafeFocusText(
            focus.text
        )
    ){

        return null;

    }


    if(
        !isSafeInsightText(
            focus.text
        )
    ){

        return null;

    }


    return clone(
        focus
    );

}


/*==============================================================================*
*VALIDATE CONTRADICTION
*==============================================================================*/

function sanitizeContradiction(
    contradiction
){

    if(
        !contradiction ||
        !contradiction.text
    ){

        return null;

    }


    if(
        !isSafeInsightText(
            contradiction.text
        )
    ){

        return null;

    }


    return clone(
        contradiction
    );

}


/*==============================================================================*
*RUN FINAL CONTENT SAFETY PASS
*
*This function will be called again by Section H before saving an Insight.
*==============================================================================*/

function runContentSafetyPass(
    content
){

    if(
        !content ||
        typeof content!=="object"
    ){

        return null;

    }


    const safe=
        clone(
            content
        );


    /*==========================================================================
    SCIENCE
    ==========================================================================*/

    safe.scienceAndYourDay=
        sanitizeScienceItems(
            safe.scienceAndYourDay
        );


    /*==========================================================================
    PROMISE
    ==========================================================================*/

    safe.promiseInsight=
        sanitizePromiseReflection(
            safe.promiseInsight
        );


    /*==========================================================================
    TOMORROW
    ==========================================================================*/

    safe.tomorrowFocus=
        sanitizeTomorrowFocus(
            safe.tomorrowFocus
        );


    /*==========================================================================
    DOCTOR QUESTIONS
    ==========================================================================*/

    safe.doctorQuestions=
        sanitizeDoctorQuestions(
            safe.doctorQuestions
        );


    /*==========================================================================
    CONTRADICTION
    ==========================================================================*/

    safe.contradictionObservation=
        sanitizeContradiction(
            safe.contradictionObservation
        );


    return safe;

}


/*==============================================================================*
*PUBLIC ENGINE API — SECTION G
*==============================================================================*/

window.TrestleW007Engine.getDoctorQuestions=
    function(){

        if(!todayW005){

            readEngineInputs();

        }


        return clone(
            buildDoctorQuestions()
        );

    };


window.TrestleW007Engine.getDoctorSectionIntro=
    function(){

        return getDoctorSectionIntro();

    };


window.TrestleW007Engine.getContradictionObservation=
    function(){

        if(!todayW005){

            readEngineInputs();

        }


        return clone(
            buildContradictionObservation()
        );

    };


window.TrestleW007Engine.isSafeText=
    function(text){

        return isSafeInsightText(
            text
        );

    };


/*==============================================================================*
*SECTION G END
*
*SECTION H CONTINUES DIRECTLY BELOW.
*
*SECTION H WILL:
*
*1. Assemble the final Insight object
*2. Apply sparse-data behavior
*3. Apply 7 PM generation rule
*4. Save/load local archive
*5. Keep only 7 Insights
*6. Export final public W007 Engine API
*7. Close the engine scope
*
*DO NOT ADD })(); YET.
*==============================================================================*/
/*==============================================================================*
*SECTION H
*FINAL INSIGHT ASSEMBLY
*7 PM GENERATION
*LOCAL ARCHIVE
*7-INSIGHT CLEANUP
*PUBLIC API
*ENGINE CLOSE
*==============================================================================*/


/*==============================================================================*
*FINAL RUNTIME
*==============================================================================*/

let finalInsightData=null;


/*==============================================================================*
*READ ARCHIVE
*==============================================================================*/

function readInsightArchive(){

    try{

        const raw=
            localStorage.getItem(
                ENGINE_CONFIG.archiveKey
            );


        if(!raw){

            return{};

        }


        const parsed=
            JSON.parse(raw);


        return(
            parsed &&
            typeof parsed==="object" &&
            !Array.isArray(parsed)
        )
            ? parsed
            : {};

    }

    catch(error){

        console.warn(
            "TRESTLE W007: Unable to read Insight archive.",
            error
        );


        return{};

    }

}


/*==============================================================================*
*WRITE ARCHIVE
*==============================================================================*/

function writeInsightArchive(
    archive
){

    try{

        localStorage.setItem(

            ENGINE_CONFIG.archiveKey,

            JSON.stringify(
                archive || {}
            )

        );


        return true;

    }

    catch(error){

        console.warn(
            "TRESTLE W007: Unable to save Insight archive.",
            error
        );


        return false;

    }

}


/*==============================================================================*
*CLEAN ARCHIVE
*
*Keep only newest 7 generated Insights.
*==============================================================================*/

function cleanInsightArchive(
    archive
){

    if(
        !archive ||
        typeof archive!=="object"
    ){

        return{};

    }


    const entries=
        Object.keys(archive)

            .map(

                function(date){

                    return{

                        date:
                            date,

                        insight:
                            archive[date]

                    };

                }

            )

            .filter(

                function(item){

                    return(
                        item.insight &&
                        typeof item.insight===
                            "object"
                    );

                }

            )

            .sort(

                function(a,b){

                    return String(
                        b.date
                    ).localeCompare(
                        String(
                            a.date
                        )
                    );

                }

            );


    const limited=
        entries.slice(
            0,
            ENGINE_CONFIG.archiveLimit
        );


    const cleaned={};


    limited.forEach(

        function(item){

            cleaned[
                item.date
            ]=
                item.insight;

        }

    );


    return cleaned;

}


/*==============================================================================*
*CLEAN ARCHIVE NOW
*==============================================================================*/

function cleanupArchive(){

    const archive=
        readInsightArchive();


    const cleaned=
        cleanInsightArchive(
            archive
        );


    writeInsightArchive(
        cleaned
    );


    return clone(
        cleaned
    );

}


/*==============================================================================*
*GET SAVED INSIGHT BY DATE
*==============================================================================*/

function getSavedInsight(
    date
){

    const archive=
        readInsightArchive();


    if(
        !date ||
        !archive[date]
    ){

        return null;

    }


    return clone(
        archive[date]
    );

}


/*==============================================================================*
*GET TODAY'S SAVED INSIGHT
*==============================================================================*/

function getTodaySavedInsight(){

    return getSavedInsight(
        getTodayKey()
    );

}


/*==============================================================================*
*SAVE INSIGHT
*==============================================================================*/

function saveInsight(
    insight
){

    if(
        !insight ||
        !insight.date
    ){

        return false;

    }


    let archive=
        readInsightArchive();


    archive[
        insight.date
    ]=
        clone(
            insight
        );


    archive=
        cleanInsightArchive(
            archive
        );


    return writeInsightArchive(
        archive
    );

}


/*==============================================================================*
*GET ARCHIVE LIST
*==============================================================================*/

function getArchiveList(){

    const archive=
        cleanupArchive();


    return Object.keys(
        archive
    )

        .sort(

            function(a,b){

                return String(
                    b
                ).localeCompare(
                    String(
                        a
                    )
                );

            }

        )

        .map(

            function(date){

                const insight=
                    archive[date];


                return{

                    date:
                        date,

                    generatedAt:
                        insight
                            ? safeString(
                                insight.generatedAt
                            )
                            : "",

                    promise:
                        (
                            insight &&
                            insight.profile
                        )
                            ? safeString(
                                insight
                                    .profile
                                    .promise
                            )
                            : "",

                    dataLevel:
                        (
                            insight &&
                            insight.dataCoverage
                        )
                            ? safeString(
                                insight
                                    .dataCoverage
                                    .dataLevel
                            )
                            : ""

                };

            }

        );

}


/*==============================================================================*
*GET SPARSE DATA CONFIG
*==============================================================================*/

function getSparseDataConfig(
    level
){

    if(
        !insightData ||
        !insightData.sparseDataWording
    ){

        return null;

    }


    const map={

        NONE:"none",

        VERY_LIGHT:"veryLight",

        LIGHT:"light",

        FULL:"full"

    };


    const key=
        map[level];


    return key
        ? insightData
            .sparseDataWording[
                key
            ] || null
        : null;

}


/*==============================================================================*
*GET SPARSE INTRO
*==============================================================================*/

function getSparseIntro(
    level
){

    const config=
        getSparseDataConfig(
            level
        );


    if(!config){

        return"";

    }


    if(
        Array.isArray(
            config.introVariants
        )
    ){

        return chooseStableVariant(

            config.introVariants,

            "sparse_intro_" +
            level

        );

    }


    return safeString(
        config.message
    );

}


/*==============================================================================*
*GET CLOSING
*==============================================================================*/

function getClosingText(){

    const variants=
        insightData &&
        Array.isArray(
            insightData.closingVariants
        )
            ? insightData
                .closingVariants
            : [];


    if(!variants.length){

        return(
            "A reflection from your day, not a judgement of it."
        );

    }


    return chooseStableVariant(

        variants,

        "w007_closing"

    );

}


/*==============================================================================*
*GET DISCLAIMER
*==============================================================================*/

function getDisclaimer(){

    const profile=
        getCurrentProfile();


    if(
        profile.lifeStage==="Pregnant" ||
        profile.diabetesProfile===
            "Gestational Diabetes"
    ){

        return safeString(

            insightData &&
            insightData
                .pregnancyDisclaimer

                ? insightData
                    .pregnancyDisclaimer

                : insightData
                    .generalDisclaimer

        );

    }


    return safeString(

        insightData &&
        insightData
            .generalDisclaimer

            ? insightData
                .generalDisclaimer

            : ""

    );

}


/*==============================================================================*
*BUILD DATA COVERAGE OBJECT
*==============================================================================*/

function buildFinalDataCoverage(){

    const state=
        getCurrentPatterns();


    return clone(

        state &&
        state.dataCoverage

            ? state.dataCoverage

            : {

                checkinsLogged:0,

                bloodSugarReadings:0,

                mealsRecorded:0,

                movementSessions:0,

                dataLevel:"NONE"

            }

    );

}


/*==============================================================================*
*BUILD USED SOURCE LIST
*==============================================================================*/

function buildFinalSourceIds(
    scienceItems
){

    const ids=[];


    if(
        !Array.isArray(
            scienceItems
        )
    ){

        return ids;

    }


    scienceItems.forEach(

        function(item){

            if(
                !item ||
                !Array.isArray(
                    item.sourceIds
                )
            ){

                return;

            }


            item.sourceIds.forEach(

                function(id){

                    if(
                        !ids.includes(id)
                    ){

                        ids.push(id);

                    }

                }

            );

        }

    );


    return ids.slice(
        0,
        3
    );

}


/*==============================================================================*
*TRESTLE INTELLIGENCE v2
*STRUCTURED DAILY SNAPSHOT + LOCAL LONGITUDINAL INTELLIGENCE
*
*Privacy:
*• Reads only the existing browser-local W007 archive.
*• Writes only inside the existing browser-local Insight object.
*• No backend, network, AI API or server-side wellness storage.
*
*Compatibility:
*• Old v1 archived Insights remain readable.
*• Only archived Insights containing intelligenceSnapshot participate in
*  THREAD / CONTRAST calculations.
*==============================================================================*/


function getSnapshotComparableMealInterval(){

    if(
        !derivedPatterns ||
        !derivedPatterns.values
    ){

        return null;

    }


    const breakfastLunch=
        safeNumber(
            derivedPatterns
                .values
                .breakfastLunchIntervalMinutes
        );


    if(breakfastLunch!==null){

        return breakfastLunch;

    }


    const lunchDinner=
        safeNumber(
            derivedPatterns
                .values
                .lunchDinnerIntervalMinutes
        );


    return lunchDinner;

}


function buildIntelligenceSnapshot(){

    if(!todayW005){

        readEngineInputs();

    }


    if(!derivedPatterns){

        derivePatterns();

    }


    const values=
        (
            derivedPatterns &&
            derivedPatterns.values
        )
            ? derivedPatterns.values
            : {};


    const sleep=
        getLatest("sleep");

    const stress=
        getLatest("stress");

    const mood=
        getLatest("mood");

    const water=
        getLatest("water");

    const medication=
        getLatest("medication");


    const movementHistory=
        getHistory("movement");

    const mealHistory=
        getHistory("meal");

    const glucoseHistory=
        getHistory("bloodSugar");


    return{

        version:"2.0",

        date:
            getTodayKey(),

        promise:
            profileContext
                ? safeString(
                    profileContext.promise
                )
                : "",


        sleep:{

            recorded:
                Boolean(sleep),

            hours:
                sleep && sleep.data
                    ? safeNumber(
                        sleep.data.hours
                    )
                    : null,

            quality:
                sleep && sleep.data
                    ? safeString(
                        sleep.data.quality
                    )
                    : ""

        },


        stress:{

            recorded:
                Boolean(stress),

            level:
                stress && stress.data
                    ? safeString(
                        stress.data.level
                    )
                    : "",

            source:
                stress && stress.data
                    ? safeString(
                        stress.data.source
                    )
                    : ""

        },


        mood:{

            recorded:
                Boolean(mood),

            value:
                mood && mood.data
                    ? safeString(
                        mood.data.mood
                    )
                    : ""

        },


        movement:{

            recorded:
                Boolean(
                    movementHistory.length ||
                    getLatest("movement")
                ),

            totalMinutes:
                safeNumber(
                    values.movementMinutes
                ),

            sessionCount:
                safeNumber(
                    values.movementSessions
                )

        },


        meals:{

            recorded:
                Boolean(
                    mealHistory.length ||
                    getLatest("meal")
                ),

            mealCount:
                safeNumber(
                    values.mealCount
                ),

            comparableIntervalMinutes:
                getSnapshotComparableMealInterval(),

            longInterval:
                Boolean(
                    derivedPatterns &&
                    derivedPatterns.flags &&
                    derivedPatterns
                        .flags
                        .long_recorded_meal_interval
                )

        },


        water:{

            recorded:
                Boolean(water),

            glasses:
                water && water.data
                    ? safeNumber(
                        water.data.glasses
                    )
                    : null

        },


        bloodSugar:{

            recorded:
                Boolean(
                    glucoseHistory.length ||
                    getLatest("bloodSugar")
                ),

            readingCount:
                safeNumber(
                    values.glucoseReadingCount
                ),

            distinctContexts:
                safeNumber(
                    values.glucoseDistinctContexts
                )

        },


        medication:{

            recorded:
                Boolean(medication),

            status:
                medication && medication.data
                    ? safeString(
                        medication.data.status
                    )
                    : ""

        },


        triggeredPatternIds:
            derivedPatterns &&
            derivedPatterns.flags
                ? Object.keys(
                    derivedPatterns.flags
                ).filter(
                    function(id){
                        return Boolean(
                            derivedPatterns.flags[id]
                        );
                    }
                )
                : []

    };

}


/*==============================================================================*
*READ RECENT STRUCTURED SNAPSHOTS
*
*Returns archived snapshots newest-first.
*Today's unsaved report is not included here.
*==============================================================================*/

function getRecentIntelligenceSnapshots(){

    const archive=
        readInsightArchive();


    return Object.keys(
        archive
    )

        .sort(
            function(a,b){
                return String(b)
                    .localeCompare(
                        String(a)
                    );
            }
        )

        .map(
            function(date){

                const insight=
                    archive[date];


                if(
                    !insight ||
                    typeof insight!=="object" ||
                    !insight.intelligenceSnapshot ||
                    typeof insight.intelligenceSnapshot!=="object"
                ){

                    return null;

                }


                return clone(
                    insight.intelligenceSnapshot
                );

            }
        )

        .filter(Boolean)

        .slice(
            0,
            ENGINE_CONFIG.archiveLimit
        );

}


/*==============================================================================*
*NOTICE
*
*Day-1 eligible.
*Prefers a derived relationship or contextual observation over restating
*simple raw input.
*==============================================================================*/

function buildTrestleNotice(snapshot){

    if(!snapshot){

        return null;

    }


    if(
        snapshot.stress.recorded &&
        snapshot.stress.level==="High" &&
        snapshot.stress.source
    ){

        return{

            id:"notice_high_stress_source",

            domain:"stress",

            title:"What stood out today",

            text:
                "You recorded High stress today and identified " +
                snapshot.stress.source +
                " as its main source.",

            evidenceClass:"RECORDED_FACT"

        };

    }


    if(
        snapshot.meals.recorded &&
        snapshot.meals.comparableIntervalMinutes!==null &&
        snapshot.meals.comparableIntervalMinutes>=330
    ){

        const minutes=
            snapshot.meals
                .comparableIntervalMinutes;

        const hours=
            Math.floor(
                minutes/60
            );

        const remainder=
            minutes%60;

        return{

            id:"notice_long_meal_interval",

            domain:"meal",

            title:"What stood out today",

            text:
                "One recorded main-meal interval was " +
                hours +
                " hr" +
                (
                    remainder
                        ? " " + remainder + " min"
                        : ""
                ) +
                " today. It may be worth simply noticing whether the same rhythm appears again.",

            evidenceClass:"CALCULATED_FACT"

        };

    }


    if(
        snapshot.movement.recorded &&
        snapshot.movement.sessionCount!==null &&
        snapshot.movement.sessionCount>=2 &&
        snapshot.movement.totalMinutes!==null
    ){

        return{

            id:"notice_accumulated_movement",

            domain:"movement",

            title:"What stood out today",

            text:
                "Movement appeared in " +
                snapshot.movement.sessionCount +
                " recorded periods today, adding up to " +
                snapshot.movement.totalMinutes +
                " minutes.",

            evidenceClass:"CALCULATED_FACT"

        };

    }


    if(
        snapshot.sleep.recorded &&
        snapshot.stress.recorded &&
        snapshot.sleep.hours!==null
    ){

        return{

            id:"notice_sleep_stress_pair",

            domain:"cross",

            title:"What stood out today",

            text:
                "You recorded " +
                snapshot.sleep.hours +
                " hours of sleep and " +
                snapshot.stress.level +
                " stress today. One day does not establish a relationship, but the pair is worth remembering if it repeats.",

            evidenceClass:"CONTEXTUAL_INTERPRETATION"

        };

    }


    if(
        snapshot.sleep.recorded &&
        snapshot.sleep.hours!==null &&
        snapshot.sleep.quality
    ){

        return{

            id:"notice_sleep",

            domain:"sleep",

            title:"What stood out today",

            text:
                "You recorded " +
                snapshot.sleep.hours +
                " hours of sleep and described its quality as " +
                snapshot.sleep.quality +
                ".",

            evidenceClass:"RECORDED_FACT"

        };

    }


    return null;

}


/*==============================================================================*
*THREAD
*
*Minimum 3 available structured Insights including today.
*Thresholds:
*• 2/3  -> may be beginning to appear
*• 3/4–5 -> appeared repeatedly
*• 4+/6–7 -> recurring feature
*==============================================================================*/

function getThreadPhrase(
    count,
    total
){

    if(
        total>=6 &&
        count>=4
    ){

        return "has been a recurring feature of your recent recorded days";

    }


    if(
        total>=4 &&
        count>=3
    ){

        return "has appeared repeatedly across your recent recorded days";

    }


    return "may be beginning to appear across your recent recorded days";

}


function buildTrestleThread(
    snapshot,
    priorSnapshots
){

    const all=
        [snapshot]
            .concat(
                Array.isArray(priorSnapshots)
                    ? priorSnapshots
                    : []
            )
            .slice(
                0,
                ENGINE_CONFIG.archiveLimit
            );


    if(all.length<3){

        return null;

    }


    const candidates=[];


    const stressDays=
        all.filter(
            function(item){
                return(
                    item.stress &&
                    item.stress.recorded
                );
            }
        );


    if(stressDays.length>=3){

        const professionalHigh=
            stressDays.filter(
                function(item){
                    return(
                        item.stress.level==="High" &&
                        item.stress.source==="Professional / Work"
                    );
                }
            ).length;


        if(
            professionalHigh>=2 &&
            professionalHigh/stressDays.length>=0.5
        ){

            candidates.push({

                id:"thread_professional_high_stress",

                domain:"stress",

                count:
                    professionalHigh,

                total:
                    stressDays.length,

                priority:100,

                text:
                    "High stress with Professional / Work selected as the main source " +
                    getThreadPhrase(
                        professionalHigh,
                        stressDays.length
                    ) +
                    " (" +
                    professionalHigh +
                    " of " +
                    stressDays.length +
                    " comparable recorded days)."

            });

        }

    }


    const mealDays=
        all.filter(
            function(item){
                return(
                    item.meals &&
                    item.meals.recorded &&
                    item.meals.comparableIntervalMinutes!==null
                );
            }
        );


    if(mealDays.length>=3){

        const longDays=
            mealDays.filter(
                function(item){
                    return(
                        item.meals
                            .comparableIntervalMinutes>=330
                    );
                }
            ).length;


        if(
            longDays>=2 &&
            longDays/mealDays.length>=0.5
        ){

            candidates.push({

                id:"thread_long_meal_interval",

                domain:"meal",

                count:
                    longDays,

                total:
                    mealDays.length,

                priority:90,

                text:
                    "A recorded main-meal interval of 5½ hours or longer " +
                    getThreadPhrase(
                        longDays,
                        mealDays.length
                    ) +
                    " (" +
                    longDays +
                    " of " +
                    mealDays.length +
                    " comparable recorded days)."

            });

        }

    }


    const sleepDays=
        all.filter(
            function(item){
                return(
                    item.sleep &&
                    item.sleep.recorded &&
                    item.sleep.hours!==null
                );
            }
        );


    if(sleepDays.length>=3){

        const shorterDays=
            sleepDays.filter(
                function(item){
                    return item.sleep.hours<7;
                }
            ).length;


        if(
            shorterDays>=2 &&
            shorterDays/sleepDays.length>=0.5
        ){

            candidates.push({

                id:"thread_shorter_sleep",

                domain:"sleep",

                count:
                    shorterDays,

                total:
                    sleepDays.length,

                priority:85,

                text:
                    "Sleep below 7 recorded hours " +
                    getThreadPhrase(
                        shorterDays,
                        sleepDays.length
                    ) +
                    " (" +
                    shorterDays +
                    " of " +
                    sleepDays.length +
                    " comparable recorded days)."

            });

        }

    }


    const movementDays=
        all.filter(
            function(item){
                return(
                    item.movement &&
                    item.movement.recorded &&
                    item.movement.totalMinutes!==null
                );
            }
        );


    if(movementDays.length>=3){

        const multiSessionDays=
            movementDays.filter(
                function(item){
                    return(
                        item.movement.sessionCount!==null &&
                        item.movement.sessionCount>=2
                    );
                }
            ).length;


        if(
            multiSessionDays>=2 &&
            multiSessionDays/movementDays.length>=0.5
        ){

            candidates.push({

                id:"thread_distributed_movement",

                domain:"movement",

                count:
                    multiSessionDays,

                total:
                    movementDays.length,

                priority:70,

                text:
                    "Movement spread across more than one recorded period " +
                    getThreadPhrase(
                        multiSessionDays,
                        movementDays.length
                    ) +
                    " (" +
                    multiSessionDays +
                    " of " +
                    movementDays.length +
                    " comparable recorded days)."

            });

        }

    }


    if(!candidates.length){

        return null;

    }


    candidates.sort(
        function(a,b){
            return b.priority-a.priority;
        }
    );


    const chosen=
        candidates[0];


    return{

        id:
            chosen.id,

        domain:
            chosen.domain,

        title:"What keeps appearing",

        text:
            chosen.text,

        count:
            chosen.count,

        comparableDays:
            chosen.total,

        evidenceClass:"LONGITUDINAL_RECORDED_PATTERN",

        caution:
            "This is a pattern in what you recorded, not a diagnosis or proof of cause and effect."

    };

}


/*==============================================================================*
*CONTRAST
*
*Minimum 4 comparable days and at least 2 observations on each side.
*Current v2 contrast:
*Movement on Good-mood days vs Low-mood days.
*==============================================================================*/

function averageNumbers(values){

    const valid=
        values.filter(
            function(value){
                return(
                    typeof value==="number" &&
                    Number.isFinite(value)
                );
            }
        );


    if(!valid.length){

        return null;

    }


    return valid.reduce(
        function(total,value){
            return total+value;
        },
        0
    )/valid.length;

}


function buildTrestleContrast(
    snapshot,
    priorSnapshots
){

    const all=
        [snapshot]
            .concat(
                Array.isArray(priorSnapshots)
                    ? priorSnapshots
                    : []
            )
            .slice(
                0,
                ENGINE_CONFIG.archiveLimit
            );


    const comparable=
        all.filter(
            function(item){
                return(
                    item.mood &&
                    item.mood.recorded &&
                    item.movement &&
                    item.movement.recorded &&
                    item.movement.totalMinutes!==null
                );
            }
        );


    if(comparable.length<4){

        return null;

    }


    const good=
        comparable.filter(
            function(item){
                return item.mood.value==="Good";
            }
        );


    const low=
        comparable.filter(
            function(item){
                return item.mood.value==="Low";
            }
        );


    if(
        good.length<2 ||
        low.length<2
    ){

        return null;

    }


    const goodAverage=
        averageNumbers(
            good.map(
                function(item){
                    return item.movement.totalMinutes;
                }
            )
        );


    const lowAverage=
        averageNumbers(
            low.map(
                function(item){
                    return item.movement.totalMinutes;
                }
            )
        );


    if(
        goodAverage===null ||
        lowAverage===null ||
        Math.abs(
            goodAverage-lowAverage
        )<10
    ){

        return null;

    }


    const higherOnGood=
        goodAverage>lowAverage;


    return{

        id:"contrast_mood_movement",

        domain:"mood_movement",

        title:"What looked different",

        text:
            "Across your comparable recent recorded days, movement was generally " +
            (
                higherOnGood
                    ? "higher on days when you recorded Good mood than on days when you recorded Low mood."
                    : "lower on days when you recorded Good mood than on days when you recorded Low mood."
            ),

        groups:{

            goodMoodDays:
                good.length,

            lowMoodDays:
                low.length,

            goodMoodAverageMovementMinutes:
                Math.round(
                    goodAverage
                ),

            lowMoodAverageMovementMinutes:
                Math.round(
                    lowAverage
                )

        },

        evidenceClass:"LONGITUDINAL_CONTRAST",

        caution:
            "This does not establish that movement caused the difference in mood. It is simply a contrast in your recorded information."

    };

}


/*==============================================================================*
*BUILD COMPLETE v2 INTELLIGENCE LAYER
*==============================================================================*/

function buildTrestleIntelligence(){

    const snapshot=
        buildIntelligenceSnapshot();


    const priorSnapshots=
        getRecentIntelligenceSnapshots()
            .filter(
                function(item){
                    return(
                        item.date!==
                        snapshot.date
                    );
                }
            );


    return{

        snapshot:
            snapshot,

        notice:
            buildTrestleNotice(
                snapshot
            ),

        thread:
            buildTrestleThread(
                snapshot,
                priorSnapshots
            ),

        contrast:
            buildTrestleContrast(
                snapshot,
                priorSnapshots
            ),

        availableStructuredDays:
            Math.min(
                1+priorSnapshots.length,
                ENGINE_CONFIG.archiveLimit
            )

    };

}


/*==============================================================================*
*BUILD FINAL INSIGHT CONTENT
*==============================================================================*/

function buildFinalInsightContent(){

    if(!insightData){

        loadInsightData();

    }


    if(!todayW005){

        readEngineInputs();

    }


    if(!derivedPatterns){

        derivePatterns();

    }


    if(!relevanceContext){

        buildRelevanceContext();

    }


    const identity=
        readIdentityContext();


    const profile=
        readProfileContext();


    const coverage=
        buildFinalDataCoverage();


    const dayAtGlance=
        buildDayAtGlance();


    let science=
        buildScienceAndYourDay();


    let promiseReflection=
        buildPromiseReflection();


    let tomorrowFocus=
        buildTomorrowFocus();


    let doctorQuestions=
        buildDoctorQuestions();


    let contradiction=
        buildContradictionObservation();


    const trestleIntelligence=
        buildTrestleIntelligence();


    const sparseIntro=
        getSparseIntro(
            coverage.dataLevel
        );


    /*==========================================================================
    NONE
    No substantive Insight.
    ==========================================================================*/

    if(
        coverage.dataLevel==="NONE"
    ){

        return{

            version:
                ENGINE_CONFIG.version,

            date:
                getTodayKey(),

            generatedAt:
                getTimestamp(),

            identity:
                clone(
                    identity
                ),

            profile:
                clone(
                    profile
                ),

            dataCoverage:
                coverage,

            sparseIntro:
                sparseIntro,

            dayAtGlance:{
                intro:"",
                itemCount:0,
                items:[],
                factualObservations:[],
                mealTimeline:[],
                bloodSugarTimeline:[]
            },

            intelligenceSnapshot:
                clone(
                    trestleIntelligence.snapshot
                ),

            notice:null,

            thread:null,

            contrast:null,

            intelligenceDays:
                trestleIntelligence
                    .availableStructuredDays,

            scienceAndYourDay:[],

            promiseInsight:null,

            tomorrowFocus:null,

            doctorQuestions:[],

            doctorSectionIntro:"",

            contradictionObservation:null,

            closing:
                getClosingText(),

            disclaimer:
                getDisclaimer(),

            sourceIds:[],

            allowPdf:false,

            allowShare:false,

            status:"INSUFFICIENT_DATA"

        };

    }


    /*==========================================================================
    VERY LIGHT
    Keep content deliberately restrained.
    ==========================================================================*/

    if(
        coverage.dataLevel==="VERY_LIGHT"
    ){

        science=
            Array.isArray(science)
                ? science.slice(
                    0,
                    1
                )
                : [];


        doctorQuestions=
            Array.isArray(
                doctorQuestions
            )
                ? doctorQuestions.slice(
                    0,
                    1
                )
                : [];


        contradiction=
            null;

    }


    const rawContent={

        scienceAndYourDay:
            science,

        promiseInsight:
            promiseReflection,

        tomorrowFocus:
            tomorrowFocus,

        doctorQuestions:
            doctorQuestions,

        contradictionObservation:
            contradiction

    };


    const safeContent=
        runContentSafetyPass(
            rawContent
        ) || {

            scienceAndYourDay:[],

            promiseInsight:null,

            tomorrowFocus:null,

            doctorQuestions:[],

            contradictionObservation:null

        };


    const sourceIds=
        buildFinalSourceIds(
            safeContent
                .scienceAndYourDay
        );


    const sparseConfig=
        getSparseDataConfig(
            coverage.dataLevel
        );


    return{

        version:
            ENGINE_CONFIG.version,

        date:
            getTodayKey(),

        generatedAt:
            getTimestamp(),

        identity:
            clone(
                identity
            ),

        profile:
            clone(
                profile
            ),

        dataCoverage:
            coverage,

        sparseIntro:
            sparseIntro,

        dayAtGlance:
            clone(
                dayAtGlance
            ),

        intelligenceSnapshot:
            clone(
                trestleIntelligence.snapshot
            ),

        notice:
            clone(
                trestleIntelligence.notice
            ),

        thread:
            clone(
                trestleIntelligence.thread
            ),

        contrast:
            clone(
                trestleIntelligence.contrast
            ),

        intelligenceDays:
            trestleIntelligence
                .availableStructuredDays,

        scienceAndYourDay:
            clone(
                safeContent
                    .scienceAndYourDay
            ),

        promiseInsight:
            clone(
                safeContent
                    .promiseInsight
            ),

        tomorrowFocus:
            clone(
                safeContent
                    .tomorrowFocus
            ),

        doctorQuestions:
            clone(
                safeContent
                    .doctorQuestions
            ),

        doctorSectionIntro:

            safeContent
                .doctorQuestions &&
            safeContent
                .doctorQuestions
                .length

                ? getDoctorSectionIntro()

                : "",

        contradictionObservation:
            clone(
                safeContent
                    .contradictionObservation
            ),

        closing:
            getClosingText(),

        disclaimer:
            getDisclaimer(),

        sourceIds:
            sourceIds,

        allowPdf:

            sparseConfig &&
            typeof sparseConfig.allowPdf===
                "boolean"

                ? sparseConfig.allowPdf

                : true,

        allowShare:

            sparseConfig &&
            typeof sparseConfig.allowShare===
                "boolean"

                ? sparseConfig.allowShare

                : true,

        status:"READY"

    };

}


/*==============================================================================*
*VALIDATE FINAL INSIGHT
*==============================================================================*/

function validateFinalInsight(
    insight
){

    if(
        !insight ||
        typeof insight!=="object"
    ){

        return false;

    }


    if(
        !safeString(
            insight.date
        )
    ){

        return false;

    }


    if(
        !safeString(
            insight.generatedAt
        )
    ){

        return false;

    }


    if(
        !insight.dataCoverage ||
        typeof insight.dataCoverage!==
            "object"
    ){

        return false;

    }


    if(
        !insight.dayAtGlance ||
        typeof insight.dayAtGlance!==
            "object"
    ){

        return false;

    }


    if(
        !safeString(
            insight.disclaimer
        )
    ){

        return false;

    }


    if(
        Array.isArray(
            insight.scienceAndYourDay
        ) &&
        insight.scienceAndYourDay.length>2
    ){

        return false;

    }


    if(
        Array.isArray(
            insight.doctorQuestions
        ) &&
        insight.doctorQuestions.length>3
    ){

        return false;

    }


    /*==========================================================================
    FINAL TEXT SAFETY
    ==========================================================================*/

    const texts=[];


    if(
        insight.notice &&
        insight.notice.text
    ){

        texts.push(
            insight.notice.text
        );

    }


    if(
        insight.thread &&
        insight.thread.text
    ){

        texts.push(
            insight.thread.text
        );

    }


    if(
        insight.contrast &&
        insight.contrast.text
    ){

        texts.push(
            insight.contrast.text
        );

    }


    if(
        insight.promiseInsight &&
        insight.promiseInsight.text
    ){

        texts.push(
            insight.promiseInsight.text
        );

    }


    if(
        insight.tomorrowFocus &&
        insight.tomorrowFocus.text
    ){

        texts.push(
            insight.tomorrowFocus.text
        );

    }


    if(
        insight
            .contradictionObservation &&
        insight
            .contradictionObservation
            .text
    ){

        texts.push(
            insight
                .contradictionObservation
                .text
        );

    }


    if(
        Array.isArray(
            insight.scienceAndYourDay
        )
    ){

        insight
            .scienceAndYourDay
            .forEach(

                function(item){

                    if(
                        item &&
                        item.text
                    ){

                        texts.push(
                            item.text
                        );

                    }

                }

            );

    }


    const unsafe=
        texts.some(

            function(text){

                return(
                    !isSafeInsightText(
                        text
                    )
                );

            }

        );


    if(unsafe){

        return false;

    }


    return true;

}


/*==============================================================================*
*GENERATE INSIGHT NOW
*
*Internal function.
*
*Normally called automatically only after 7 PM.
*==============================================================================*/

function generateInsightNow(){

    const content=
        buildFinalInsightContent();


    if(
        !content ||
        !validateFinalInsight(
            content
        )
    ){

        console.warn(
            "TRESTLE W007: Final Insight validation failed."
        );


        return null;

    }


    finalInsightData=
        content;


    if(
        content.status==="READY"
    ){

        saveInsight(
            content
        );

    }


    return clone(
        finalInsightData
    );

}


/*==============================================================================*
*GET OR GENERATE TODAY'S INSIGHT
*
*Core 7 PM behavior.
*==============================================================================*/

function getOrGenerateTodayInsight(){

    cleanupArchive();


    const today=
        getTodayKey();


    const saved=
        getSavedInsight(
            today
        );


    if(saved){

        finalInsightData=
            saved;


        return{

            status:"READY",

            source:"ARCHIVE",

            insight:
                clone(
                    saved
                )

        };

    }


    if(
        !isAfterGenerationTime()
    ){

        return{

            status:"WAITING",

            source:"TIME_GATE",

            message:

                insightData &&
                insightData
                    .generationRules &&
                insightData
                    .generationRules
                    .beforeGenerationMessage

                    ? insightData
                        .generationRules
                        .beforeGenerationMessage

                    : "Your end-of-day TRESTLE Insight will be ready after 7 PM.",

            insight:null

        };

    }


    const generated=
        generateInsightNow();


    if(!generated){

        return{

            status:"ERROR",

            source:"GENERATOR",

            message:

                insightData &&
                insightData
                    .fallbackMessages &&
                insightData
                    .fallbackMessages
                    .w005Unavailable

                    ? insightData
                        .fallbackMessages
                        .w005Unavailable

                    : "Today's Insight could not be prepared.",

            insight:null

        };

    }


    if(
        generated.status===
            "INSUFFICIENT_DATA"
    ){

        return{

            status:"INSUFFICIENT_DATA",

            source:"GENERATOR",

            message:
                generated.sparseIntro,

            insight:
                clone(
                    generated
                )

        };

    }


    return{

        status:"READY",

        source:"GENERATED",

        insight:
            clone(
                generated
            )

    };

}


/*==============================================================================*
*GET RECENT INSIGHT
*==============================================================================*/

function getRecentInsight(
    date
){

    return getSavedInsight(
        date
    );

}


/*==============================================================================*
*RESET CURRENT RUNTIME CACHE
*
*Does NOT delete localStorage archive.
*
*Useful after W005/profile changes during development.
*==============================================================================*/

function resetRuntimeCache(){

    insightData=null;

    profileContext=null;

    identityContext=null;

    todayW005=null;

    derivedPatterns=null;

    calculatedFacts=null;

    relevanceContext=null;

    dayAtGlanceData=null;

    scienceAndYourDayData=null;

    promiseReflectionData=null;

    tomorrowFocusData=null;

    doctorQuestionsData=null;

    contradictionData=null;

    finalInsightData=null;

}


/*==============================================================================*
*DELETE ONE LOCAL INSIGHT
*
*Primarily useful during development/testing.
*==============================================================================*/

function deleteSavedInsight(
    date
){

    const archive=
        readInsightArchive();


    if(
        !date ||
        !archive[date]
    ){

        return false;

    }


    delete archive[date];


    writeInsightArchive(
        cleanInsightArchive(
            archive
        )
    );


    if(
        date===getTodayKey()
    ){

        finalInsightData=null;

    }


    return true;

}


/*==============================================================================*
*PUBLIC API — FINAL ENGINE
*==============================================================================*/

window.TrestleW007Engine.getTodayInsight=
    function(){

        if(!insightData){

            loadInsightData();

        }


        return clone(
            getOrGenerateTodayInsight()
        );

    };


window.TrestleW007Engine.getSavedInsight=
    function(date){

        return clone(
            getRecentInsight(
                date
            )
        );

    };


window.TrestleW007Engine.getRecentInsights=
    function(){

        return clone(
            getArchiveList()
        );

    };


window.TrestleW007Engine.generateNow=
    function(){

        /*
        DEVELOPMENT / MANUAL TESTING API.

        The normal user flow does not call this before 7 PM.
        */

        if(!insightData){

            loadInsightData();

        }


        resetRuntimeCache();


        loadInsightData();

        readEngineInputs();


        return clone(
            generateInsightNow()
        );

    };


window.TrestleW007Engine.refreshRuntime=
    function(){

        resetRuntimeCache();


        loadInsightData();

        readEngineInputs();


        return{

            inputs:
                clone(
                    readEngineInputs()
                ),

            patterns:
                clone(
                    derivePatterns()
                        .patterns
                ),

            relevance:
                clone(
                    buildRelevanceContext()
                )

        };

    };


window.TrestleW007Engine.deleteSavedInsight=
    function(date){

        return deleteSavedInsight(
            date
        );

    };


window.TrestleW007Engine.clearTodayInsight=
    function(){

        return deleteSavedInsight(
            getTodayKey()
        );

    };


window.TrestleW007Engine.getArchiveKey=
    function(){

        return ENGINE_CONFIG.archiveKey;

    };


window.TrestleW007Engine.getArchiveLimit=
    function(){

        return ENGINE_CONFIG.archiveLimit;

    };


window.TrestleW007Engine.getIntelligenceSnapshot=
    function(){

        if(!todayW005){

            readEngineInputs();

        }


        if(!derivedPatterns){

            derivePatterns();

        }


        return clone(
            buildIntelligenceSnapshot()
        );

    };


window.TrestleW007Engine.getTrestleIntelligence=
    function(){

        if(!todayW005){

            readEngineInputs();

        }


        if(!derivedPatterns){

            derivePatterns();

        }


        return clone(
            buildTrestleIntelligence()
        );

    };


/*==============================================================================*
*INITIAL ENGINE PREPARATION
*
*No report is automatically rendered here.
*
*This only:
*
*1. Loads rule data
*2. Cleans archive
*
*The future W007 UI controller will call getTodayInsight().
*==============================================================================*/

function initializeEngine(){

    loadInsightData();


    cleanupArchive();


    console.log(
        "TRESTLE W007 Insight Engine Ready"
    );

}


/*==============================================================================*
*BOOTSTRAP
*==============================================================================*/

if(
    document.readyState==="loading"
){

    document.addEventListener(

        "DOMContentLoaded",

        initializeEngine

    );

}

else{

    initializeEngine();

}


/*==============================================================================*
*CLOSE ENGINE SCOPE
*==============================================================================*/

})();


/*==============================================================================*
*TRESTLE W007
*YOUR TRESTLE INSIGHT
*ENGINE
*Version 2.0
*COMPLETE
*==============================================================================*/
